module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content"
  }, [_c('breadcrumb', {
    attrs: {
      "nameSection": _vm.nameSection,
      "listRoutes": _vm.listRoutes,
      "activeRoute": _vm.activeRoute
    }
  }), _vm._v(" "), (_vm.orderDataShow) ? _c('div', [_c('div', {
    staticClass: "card-status-content"
  }, [_c('div', {
    staticClass: "card-status-block"
  }, [_c('button', {
    staticClass: "btn btn-line",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.backPage
    }
  }, [_c('i', {
    staticClass: "fas fa-long-arrow-alt-left"
  }), _vm._v("Volver\n        ")]), _vm._v(" "), (
    _vm.orderDataShow.attributes.status >= 1 && _vm.orderDataShow.attributes.status <= 3
  ) ? _c('span', {
    staticClass: "btn statusInit"
  }, [_vm._v("Inicializando")]) : _vm._e(), _vm._v(" "), (
    _vm.orderDataShow.attributes.status >= 4 && _vm.orderDataShow.attributes.status <= 7
  ) ? _c('span', {
    staticClass: "btn statusProgress"
  }, [_vm._v("En proceso")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status == 8) ? _c('span', {
    staticClass: "btn statusProgress"
  }, [_vm._v("Finalizado")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status == 10) ? _c('span', {
    staticClass: "btn statusCancel"
  }, [_vm._v("Cancelado")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status == 1) ? _c('span', {
    staticClass: "card-status-message"
  }, [_vm._v("En re-evaluación inicial")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status == 2) ? _c('span', {
    staticClass: "card-status-message"
  }, [_vm._v("Re-evaluado esperando confirmación")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status == 3) ? _c('span', {
    staticClass: "card-status-message"
  }, [_vm._v("Completando información de compra")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status == 4) ? _c('span', {
    staticClass: "card-status-message"
  }, [_vm._v("Comprado y en camino a dirección de origen")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status == 5) ? _c('span', {
    staticClass: "card-status-message"
  }, [_vm._v("Recibido en dirección de origen y en evaluación")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status == 6) ? _c('span', {
    staticClass: "card-status-message"
  }, [_vm._v("Listo para embarque")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status == 7) ? _c('span', {
    staticClass: "card-status-message"
  }, [_vm._v("En embarque")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status == 8) ? _c('span', {
    staticClass: "card-status-message"
  }, [_vm._v("Entregado correctamente")]) : _vm._e(), _vm._v(" "), (
    _vm.orderDataShow.attributes.status == 10 &&
    _vm.orderDataShow.attributes.cancelled_reason_flag == 1
  ) ? _c('span', {
    staticClass: "card-status-message"
  }, [_vm._v("Por decisión propia")]) : _vm._e(), _vm._v(" "), (
    _vm.orderDataShow.attributes.status == 10 &&
    _vm.orderDataShow.attributes.cancelled_reason_flag == 2
  ) ? _c('span', {
    staticClass: "card-status-message"
  }, [_vm._v("Por incidente en tracking")]) : _vm._e(), _vm._v(" "), (
    _vm.orderDataShow.attributes.status == 10 &&
    _vm.orderDataShow.attributes.cancelled_reason_flag == 3
  ) ? _c('span', {
    staticClass: "card-status-message"
  }, [_vm._v("Por no autorizar reposición de items")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "m"
  }, [_c('div', {
    staticClass: "nm n-1"
  }, [_c('div', {
    staticClass: "details-collapse"
  }, [_c('orderImportantInfo', {
    attrs: {
      "orderDataShow": _vm.orderDataShow,
      "fromDetail": true,
      "fromTracking": false
    },
    on: {
      "inicialize-data": _vm.inicializeDataFromImportantInfo
    }
  }), _vm._v(" "), (
    _vm.orderDataShow.attributes.status == 1 &&
    ((_vm.orderDataShow.attributes.is_from_grabr_flag &&
        _vm.orderDataShow.attributes.grabrOrder.attributes.approved_flag == 0) ||
      (_vm.orderDataShow.attributes.is_from_linio_flag &&
        _vm.orderDataShow.attributes.linioOrder.attributes.approved_flag == 0) ||
      (_vm.orderDataShow.attributes.is_from_meli_flag &&
        _vm.orderDataShow.attributes.meliOrder.attributes.approved_flag == 0))
  ) ? _c('div', {
    staticClass: "card card-standby collapsed",
    attrs: {
      "id": "headingOne",
      "data-toggle": "collapse",
      "data-target": "#collapseOne",
      "aria-expanded": "true",
      "aria-controls": "collapseOne"
    }
  }, [_c('div', {
    staticClass: "card-content-container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-content-block"
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modalReevaluation",
      modifiers: {
        "modalReevaluation": true
      }
    }],
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "disabled": _vm.noEvaluationFlag
    }
  }, [_vm._v("Evaluar")])], 1)]), _vm._v(" "), (
    (_vm.orderDataShow.attributes.is_from_grabr_flag &&
      _vm.orderDataShow.attributes.grabrOrder.attributes.approved_flag != 0) ||
    (_vm.orderDataShow.attributes.is_from_linio_flag &&
      _vm.orderDataShow.attributes.linioOrder.attributes.approved_flag != 0) ||
    (_vm.orderDataShow.attributes.is_from_meli_flag &&
      _vm.orderDataShow.attributes.meliOrder.attributes.approved_flag != 0)
  ) ? _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseOne",
      "aria-labelledby": "headingOne",
      "data-parent": "#accordion"
    }
  }, [_c('resumePurchaseOrder', {
    attrs: {
      "orderDataShow": _vm.orderDataShow
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (
    _vm.orderDataShow.attributes.status == 2 &&
    ((_vm.orderDataShow.attributes.is_from_grabr_flag &&
        _vm.orderDataShow.attributes.grabrOrder.attributes.approved_flag == 3) ||
      (_vm.orderDataShow.attributes.is_from_linio_flag &&
        _vm.orderDataShow.attributes.linioOrder.attributes.approved_flag == 3) ||
      (_vm.orderDataShow.attributes.is_from_meli_flag &&
        _vm.orderDataShow.attributes.meliOrder.attributes.approved_flag == 3))
  ) ? _c('div', {
    staticClass: "card card-cancel collapsed",
    attrs: {
      "id": "headingTwo",
      "data-toggle": "collapse",
      "data-target": "#collapseTwo",
      "aria-expanded": "true",
      "aria-controls": "collapseTwo"
    }
  }, [_c('div', {
    staticClass: "card-content-container"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-content-block"
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modalReevaluation",
      modifiers: {
        "modalReevaluation": true
      }
    }],
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "disabled": _vm.noEvaluationFlag
    }
  }, [_vm._v("Re-evaluar")]), _vm._v(" "), (
    _vm.orderDataShow.attributes.is_from_grabr_flag &&
    _vm.orderDataShow.attributes.grabrOrder.attributes.confirmation_flag ==
    0
  ) ? _c('button', {
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": function($event) {
        return _vm.ProcessService(_vm.id)
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.orderDataShow.attributes.grabrOrder.attributes.approved_flag == 1 ?
    "Reafirmar aprobación" :
    "Forzar aprobación") + "\n                ")]) : (
    _vm.orderDataShow.attributes.is_from_linio_flag &&
    _vm.orderDataShow.attributes.linioOrder.attributes.confirmation_flag ==
    0
  ) ? _c('button', {
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": function($event) {
        return _vm.ProcessService(_vm.id)
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.orderDataShow.attributes.linioOrder.attributes.approved_flag == 1 ?
    "Reafirmar aprobación" :
    "Forzar aprobación") + "\n                ")]) : (
    _vm.orderDataShow.attributes.is_from_meli_flag &&
    _vm.orderDataShow.attributes.meliOrder.attributes.confirmation_flag == 0
  ) ? _c('button', {
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": function($event) {
        return _vm.ProcessService(_vm.id)
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.approved_flag == 1 ?
    "Reafirmar aprobación" :
    "Forzar aprobación") + "\n                ")]) : _vm._e(), _vm._v(" "), (
    _vm.orderDataShow.attributes.is_from_grabr_flag &&
    this.orderDataShow.attributes.grabrOrder.attributes
    .confirmation_flag != 0
  ) ? _c('button', {
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": function($event) {
        return _vm.ProcessService(_vm.id)
      }
    }
  }, [_vm._v("\n                  Procesar\n                ")]) : (
    (_vm.orderDataShow.attributes.is_from_linio_flag &&
      this.orderDataShow.attributes.linioOrder.attributes
      .confirmation_flag != 0) ||
    (_vm.orderDataShow.attributes.is_from_meli_flag &&
      this.orderDataShow.attributes.meliOrder.attributes
      .confirmation_flag != 0)
  ) ? _c('button', {
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": function($event) {
        return _vm.ProcessService(_vm.id)
      }
    }
  }, [_vm._v("\n                  Procesar\n                ")]) : _vm._e()], 1)]), _vm._v(" "), (
    (_vm.orderDataShow.attributes.is_from_grabr_flag &&
      _vm.orderDataShow.attributes.grabrOrder.attributes.approved_flag != 0) ||
    (_vm.orderDataShow.attributes.is_from_linio_flag &&
      _vm.orderDataShow.attributes.linioOrder.attributes.approved_flag != 0) ||
    (_vm.orderDataShow.attributes.is_from_meli_flag &&
      _vm.orderDataShow.attributes.meliOrder.attributes.approved_flag != 0)
  ) ? _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseTwo",
      "aria-labelledby": "headingTwo",
      "data-parent": "#accordion"
    }
  }, [_c('resumePurchaseOrder', {
    attrs: {
      "orderDataShow": _vm.orderDataShow
    },
    on: {
      "inicialize-data": _vm.inicializeDataFromImportantInfo
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (
    _vm.orderDataShow.attributes.status == 2 &&
    ((_vm.orderDataShow.attributes.is_from_grabr_flag &&
        _vm.orderDataShow.attributes.grabrOrder.attributes.approved_flag == 1) ||
      (_vm.orderDataShow.attributes.is_from_linio_flag &&
        _vm.orderDataShow.attributes.linioOrder.attributes.approved_flag == 1) ||
      (_vm.orderDataShow.attributes.is_from_meli_flag &&
        _vm.orderDataShow.attributes.meliOrder.attributes.approved_flag == 1))
  ) ? _c('div', {
    staticClass: "card card-correct",
    attrs: {
      "id": "headingThree"
    }
  }, [_c('div', {
    staticClass: "card-content-container"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-content-block"
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modalReevaluation",
      modifiers: {
        "modalReevaluation": true
      }
    }],
    staticClass: "btn btn-primary btn-lg"
  }, [_vm._v("Re-evaluar")]), _vm._v(" "), (
    _vm.orderDataShow.attributes.is_from_grabr_flag &&
    _vm.orderDataShow.attributes.grabrOrder.attributes.confirmation_flag ==
    0
  ) ? _c('button', {
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": function($event) {
        return _vm.ProcessService(_vm.id)
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.orderDataShow.attributes.grabrOrder.attributes.approved_flag == 1 ?
    "Reafirmar aprobación" :
    "Forzar aprobación") + "\n                ")]) : (
    _vm.orderDataShow.attributes.is_from_linio_flag &&
    _vm.orderDataShow.attributes.linioOrder.attributes.confirmation_flag ==
    0
  ) ? _c('button', {
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": function($event) {
        return _vm.ProcessService(_vm.id)
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.orderDataShow.attributes.linioOrder.attributes.approved_flag == 1 ?
    "Reafirmar aprobación" :
    "Forzar aprobación") + "\n                ")]) : (
    _vm.orderDataShow.attributes.is_from_meli_flag &&
    _vm.orderDataShow.attributes.meliOrder.attributes.confirmation_flag == 0
  ) ? _c('button', {
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": function($event) {
        return _vm.ProcessService(_vm.id)
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.approved_flag == 1 ?
    "Reafirmar aprobación" :
    "Forzar aprobación") + "\n                ")]) : _vm._e(), _vm._v(" "), (
    _vm.orderDataShow.attributes.is_from_grabr_flag &&
    this.orderDataShow.attributes.grabrOrder.attributes
    .confirmation_flag != 0
  ) ? _c('button', {
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": function($event) {
        return _vm.ProcessService(_vm.id)
      }
    }
  }, [_vm._v("\n                  Procesar\n                ")]) : (
    _vm.orderDataShow.attributes.is_from_linio_flag &&
    this.orderDataShow.attributes.linioOrder.attributes
    .confirmation_flag != 0
  ) ? _c('button', {
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": function($event) {
        return _vm.ProcessService(_vm.id)
      }
    }
  }, [_vm._v("\n                  Procesar\n                ")]) : (
    _vm.orderDataShow.attributes.is_from_meli_flag &&
    this.orderDataShow.attributes.meliOrder.attributes
    .confirmation_flag != 0
  ) ? _c('button', {
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": function($event) {
        return _vm.ProcessService(_vm.id)
      }
    }
  }, [_vm._v("\n                  Procesar\n                ")]) : _vm._e(), _vm._v(" "), _vm._m(3)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseThree",
      "aria-labelledby": "headingThree",
      "data-parent": "#accordion"
    }
  }, [_c('resumePurchaseOrder', {
    attrs: {
      "orderDataShow": _vm.orderDataShow
    },
    on: {
      "inicialize-data": _vm.inicializeDataFromImportantInfo
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (
    _vm.orderDataShow.attributes.status == 2 &&
    ((_vm.orderDataShow.attributes.is_from_linio_flag &&
        _vm.orderDataShow.attributes.linioOrder.attributes.approved_flag == 2) ||
      (_vm.orderDataShow.attributes.is_from_meli_flag &&
        _vm.orderDataShow.attributes.meliOrder.attributes.approved_flag == 2))
  ) ? _c('div', {
    staticClass: "card card-standby card-wait collapsed",
    attrs: {
      "id": "headinFour",
      "data-toggle": "collapse",
      "data-target": "#collapsenFour",
      "aria-expanded": "true",
      "aria-controls": "collapseFour"
    }
  }, [_c('div', {
    staticClass: "card-content-container"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "card-content-block"
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modalReevaluation",
      modifiers: {
        "modalReevaluation": true
      }
    }],
    staticClass: "btn btn-primary btn-lg"
  }, [_vm._v("Re-evaluar")]), _vm._v(" "), (
    _vm.orderDataShow.attributes.is_from_grabr_flag &&
    _vm.orderDataShow.attributes.grabrOrder.attributes.confirmation_flag ==
    0
  ) ? _c('button', {
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": function($event) {
        return _vm.ProcessService(_vm.id)
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.orderDataShow.attributes.grabrOrder.attributes.approved_flag == 1 ?
    "Reafirmar aprobación" :
    "Forzar aprobación") + "Forzar aprobación\n                ")]) : (
    _vm.orderDataShow.attributes.is_from_linio_flag &&
    _vm.orderDataShow.attributes.linioOrder.attributes.confirmation_flag ==
    0
  ) ? _c('button', {
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": function($event) {
        return _vm.ProcessService(_vm.id)
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.orderDataShow.attributes.linioOrder.attributes.approved_flag == 1 ?
    "Reafirmar aprobación" :
    "Forzar aprobación") + "Forzar aprobación\n                ")]) : (
    _vm.orderDataShow.attributes.is_from_meli_flag &&
    _vm.orderDataShow.attributes.meliOrder.attributes.confirmation_flag == 0
  ) ? _c('button', {
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": function($event) {
        return _vm.ProcessService(_vm.id)
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.approved_flag == 1 ?
    "Reafirmar aprobación" :
    "Forzar aprobación") + "Forzar aprobación\n                ")]) : _vm._e(), _vm._v(" "), (
    _vm.orderDataShow.attributes.is_from_grabr_flag &&
    this.orderDataShow.attributes.grabrOrder.attributes
    .confirmation_flag != 0
  ) ? _c('button', {
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": function($event) {
        return _vm.ProcessService(_vm.id)
      }
    }
  }, [_vm._v("\n                  Procesar\n                ")]) : (
    _vm.orderDataShow.attributes.is_from_linio_flag &&
    this.orderDataShow.attributes.linioOrder.attributes
    .confirmation_flag != 0
  ) ? _c('button', {
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": function($event) {
        return _vm.ProcessService(_vm.id)
      }
    }
  }, [_vm._v("\n                  Procesar\n                ")]) : (
    _vm.orderDataShow.attributes.is_from_meli_flag &&
    this.orderDataShow.attributes.meliOrder.attributes
    .confirmation_flag != 0
  ) ? _c('button', {
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": function($event) {
        return _vm.ProcessService(_vm.id)
      }
    }
  }, [_vm._v("\n                  Procesar\n                ")]) : _vm._e(), _vm._v(" "), _vm._m(5)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapsenFour",
      "aria-labelledby": "headingnFour",
      "data-parent": "#accordion"
    }
  }, [_c('resumePurchaseOrder', {
    attrs: {
      "orderDataShow": _vm.orderDataShow
    },
    on: {
      "inicialize-data": _vm.inicializeDataFromImportantInfo
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status == 4) ? _c('div', {
    staticClass: "card card-correct collapsed",
    attrs: {
      "id": "headinThree"
    }
  }, [_c('div', {
    staticClass: "card-content-container"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "card-content-block"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": function($event) {
        return _vm.toTrackingView(_vm.orderDataShow)
      }
    }
  }, [_vm._v("\n                  Ir al tracking\n                ")]), _vm._v(" "), (
    (_vm.orderDataShow.attributes.is_from_linio_flag &&
      _vm.orderDataShow.attributes.linioOrder.attributes.approved_flag !==
      0 &&
      (_vm.orderDataShow.attributes.linioOrder.attributes
        .confirmation_flag === 1 ||
        _vm.orderDataShow.attributes.linioOrder.attributes
        .confirmation_flag === 2)) ||
    (_vm.orderDataShow.attributes.is_from_meli_flag &&
      _vm.orderDataShow.attributes.meliOrder.attributes.approved_flag !==
      0 &&
      (_vm.orderDataShow.attributes.meliOrder.attributes
        .confirmation_flag === 1 ||
        _vm.orderDataShow.attributes.meliOrder.attributes
        .confirmation_flag === 2))
  ) ? _c('div', {
    staticClass: "collapsed",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "data-toggle": "collapse",
      "data-target": "#collapsenThree",
      "aria-expanded": "true",
      "aria-controls": "collapseThree"
    }
  }, [_c('div', {
    staticClass: "details-text up-arrow"
  })]) : _vm._e()])]), _vm._v(" "), (
    (_vm.orderDataShow.attributes.is_from_grabr_flag &&
      _vm.orderDataShow.attributes.grabrOrder.attributes.approved_flag != 0) ||
    (_vm.orderDataShow.attributes.is_from_linio_flag &&
      _vm.orderDataShow.attributes.linioOrder.attributes.approved_flag != 0) ||
    (_vm.orderDataShow.attributes.is_from_meli_flag &&
      _vm.orderDataShow.attributes.meliOrder.attributes.approved_flag != 0)
  ) ? _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapsenThree",
      "aria-labelledby": "headingnThree",
      "data-parent": "#accordion"
    }
  }, [_c('resumePurchaseOrder', {
    attrs: {
      "orderDataShow": _vm.orderDataShow
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (
    _vm.orderDataShow.attributes.status == 5 &&
    _vm.orderDataShow.attributes.warning_expired_flag == 0
  ) ? _c('div', {
    staticClass: "card card-correct",
    attrs: {
      "id": "headinThree"
    }
  }, [_c('div', {
    staticClass: "card-content-container"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "card-content-block"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": function($event) {
        return _vm.toTrackingView(_vm.orderDataShow)
      }
    }
  }, [_vm._v("\n                  Ir al tracking\n                ")]), _vm._v(" "), (
    (_vm.orderDataShow.attributes.is_from_linio_flag &&
      _vm.orderDataShow.attributes.linioOrder.attributes.approved_flag !==
      0 &&
      (_vm.orderDataShow.attributes.linioOrder.attributes
        .confirmation_flag === 1 ||
        _vm.orderDataShow.attributes.linioOrder.attributes
        .confirmation_flag === 2)) ||
    (_vm.orderDataShow.attributes.is_from_meli_flag &&
      _vm.orderDataShow.attributes.meliOrder.attributes.approved_flag !==
      0 &&
      (_vm.orderDataShow.attributes.meliOrder.attributes
        .confirmation_flag === 1 ||
        _vm.orderDataShow.attributes.meliOrder.attributes
        .confirmation_flag === 2))
  ) ? _c('div', {
    staticClass: "collapsed",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "data-toggle": "collapse",
      "data-target": "#collapsenThree",
      "aria-expanded": "true",
      "aria-controls": "collapseThree"
    }
  }, [_c('div', {
    staticClass: "details-text up-arrow"
  })]) : _vm._e()])]), _vm._v(" "), (
    (_vm.orderDataShow.attributes.is_from_linio_flag &&
      _vm.orderDataShow.attributes.linioOrder.attributes.approved_flag != 0) ||
    (_vm.orderDataShow.attributes.is_from_meli_flag &&
      _vm.orderDataShow.attributes.meliOrder.attributes.approved_flag != 0)
  ) ? _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapsenThree",
      "aria-labelledby": "headingnThree",
      "data-parent": "#accordion"
    }
  }, [_c('resumePurchaseOrder', {
    attrs: {
      "orderDataShow": _vm.orderDataShow
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (
    _vm.orderDataShow.attributes.status == 5 &&
    _vm.orderDataShow.attributes.warning_expired_flag == 1
  ) ? _c('div', {
    staticClass: "card card-warning collapsed",
    attrs: {
      "id": "headingOne",
      "data-toggle": "collapse",
      "data-target": "#collapseOne",
      "aria-expanded": "true",
      "aria-controls": "collapseOne"
    }
  }, [_c('div', {
    staticClass: "card-content-container"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "card-content-block"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": function($event) {
        return _vm.toTrackingView(_vm.orderDataShow)
      }
    }
  }, [_vm._v("\n                  Ir al tracking\n                ")])])]), _vm._v(" "), (
    (_vm.orderDataShow.attributes.is_from_grabr_flag &&
      _vm.orderDataShow.attributes.grabrOrder.attributes.approved_flag != 0) ||
    (_vm.orderDataShow.attributes.is_from_linio_flag &&
      _vm.orderDataShow.attributes.linioOrder.attributes.approved_flag != 0) ||
    (_vm.orderDataShow.attributes.is_from_meli_flag &&
      _vm.orderDataShow.attributes.meliOrder.attributes.approved_flag != 0)
  ) ? _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseOne",
      "aria-labelledby": "headingOne",
      "data-parent": "#accordion"
    }
  }, [_c('resumePurchaseOrder', {
    attrs: {
      "orderDataShow": _vm.orderDataShow
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (
    _vm.orderDataShow.attributes.status == 5 &&
    _vm.orderDataShow.attributes.warning_expired_flag == 0
  ) ? _c('div', {
    staticClass: "card card-correct collapsed",
    attrs: {
      "id": "headingTwo",
      "data-toggle": "collapse",
      "data-target": "#collapseThree",
      "aria-expanded": "true",
      "aria-controls": "collapseThree"
    }
  }, [_vm._m(9), _vm._v(" "), (
    (_vm.orderDataShow.attributes.is_from_grabr_flag &&
      _vm.orderDataShow.attributes.grabrOrder.attributes.approved_flag != 0) ||
    (_vm.orderDataShow.attributes.is_from_linio_flag &&
      _vm.orderDataShow.attributes.linioOrder.attributes.approved_flag != 0) ||
    (_vm.orderDataShow.attributes.is_from_meli_flag &&
      _vm.orderDataShow.attributes.meliOrder.attributes.approved_flag != 0)
  ) ? _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapsenThree",
      "aria-labelledby": "headingnThree",
      "data-parent": "#accordion"
    }
  }, [_c('resumePurchaseOrder', {
    attrs: {
      "orderDataShow": _vm.orderDataShow
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.status == 6) ? _c('div', {
    staticClass: "card card-correct",
    attrs: {
      "id": "headinThree"
    }
  }, [_c('div', {
    staticClass: "card-content-container"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "card-content-block"
  }, [(
    (_vm.orderDataShow.attributes.is_from_linio_flag &&
      _vm.orderDataShow.attributes.linioOrder.attributes.approved_flag !==
      0 &&
      (_vm.orderDataShow.attributes.linioOrder.attributes
        .confirmation_flag === 1 ||
        _vm.orderDataShow.attributes.linioOrder.attributes
        .confirmation_flag === 2)) ||
    (_vm.orderDataShow.attributes.is_from_meli_flag &&
      _vm.orderDataShow.attributes.meliOrder.attributes.approved_flag !==
      0 &&
      (_vm.orderDataShow.attributes.meliOrder.attributes
        .confirmation_flag === 1 ||
        _vm.orderDataShow.attributes.meliOrder.attributes
        .confirmation_flag === 2))
  ) ? _c('div', {
    staticClass: "collapsed",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "data-toggle": "collapse",
      "data-target": "#collapsenThree",
      "aria-expanded": "true",
      "aria-controls": "collapseThree"
    }
  }, [_c('div', {
    staticClass: "details-text up-arrow"
  })]) : _vm._e()])]), _vm._v(" "), (
    (_vm.orderDataShow.attributes.is_from_grabr_flag &&
      _vm.orderDataShow.attributes.grabrOrder.attributes.approved_flag != 0) ||
    (_vm.orderDataShow.attributes.is_from_linio_flag &&
      _vm.orderDataShow.attributes.linioOrder.attributes.approved_flag != 0) ||
    (_vm.orderDataShow.attributes.is_from_meli_flag &&
      _vm.orderDataShow.attributes.meliOrder.attributes.approved_flag != 0)
  ) ? _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapsenThree",
      "aria-labelledby": "headingnThree",
      "data-parent": "#accordion"
    }
  }, [_c('resumePurchaseOrder', {
    attrs: {
      "orderDataShow": _vm.orderDataShow
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (
    _vm.orderDataShow.attributes.status == 10 &&
    _vm.orderDataShow.attributes.cancelled == 1
  ) ? _c('div', {
    staticClass: "card card-cancel collapsed",
    attrs: {
      "id": "headingTwo",
      "data-toggle": "collapse",
      "data-target": "#collapseTwo",
      "aria-expanded": "true",
      "aria-controls": "collapseTwo"
    }
  }, [_c('div', {
    staticClass: "card-content-container"
  }, [_c('div', {
    staticClass: "card-content-block"
  }, [(_vm.orderDataShow.attributes.cancelled_reason_flag == 1) ? _c('span', [_vm._v("Cancelado por decision propia")]) : (_vm.orderDataShow.attributes.cancelled_reason_flag == 2) ? _c('span', [_vm._v("Cancelado por incidente en tracking")]) : (_vm.orderDataShow.attributes.cancelled_reason_flag == 3) ? _c('span', [_vm._v("Cancelado por no autorizar reposición de items")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card-content-block"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": function($event) {
        return _vm.toTrackingView(_vm.orderDataShow)
      }
    }
  }, [_vm._v("\n                  Ir al tracking\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseTwo",
      "aria-labelledby": "headingTwo",
      "data-parent": "#accordion"
    }
  }, [_c('resumePurchaseOrder', {
    attrs: {
      "orderDataShow": _vm.orderDataShow
    }
  })], 1)]) : _vm._e()], 1), _vm._v(" "), _vm._m(11), _vm._v(" "), (_vm.orderDataShow.attributes.type === 2) ? _c('span', [_c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "clientInformation1",
      "aria-labelledby": "information1"
    }
  }, [_c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("N° de orden:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.id) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Estatus de orden:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_c('button', {
    staticClass: "button",
    class: _vm.orderDataShow.attributes.status !== 10 ?
      'button-success' :
      'button-outline',
    style: (_vm.orderDataShow.attributes.status !== 10 ?
      'cursor: not-allowed;' :
      'cursor: pointer;'),
    attrs: {
      "disabled": _vm.orderDataShow.attributes.status !== 10
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateOrderInformation('activa')
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.orderDataShow.attributes.status !== 10 ?
    "Activado" :
    "Activar") + "\n                        "), (_vm.orderDataShow.attributes.status !== 10) ? _c('img', {
    attrs: {
      "src": "/static/img/success.svg",
      "alt": ""
    }
  }) : _c('img', {
    attrs: {
      "src": "/static/img/required-icon.svg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "button",
    class: _vm.orderDataShow.attributes.status === 10 ?
      'button-success' :
      'button-outline',
    staticStyle: {
      "margin-left": "12px"
    },
    style: (_vm.orderDataShow.attributes.status === 10 ?
      'cursor: not-allowed;' :
      'cursor: pointer;'),
    attrs: {
      "disabled": _vm.orderDataShow.attributes.status === 10
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateOrderInformation('cancelada')
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.orderDataShow.attributes.status === 10 ?
    "Cancelado" :
    "Cancelar") + "\n                        "), (_vm.orderDataShow.attributes.status === 10) ? _c('img', {
    attrs: {
      "src": "/static/img/success.svg",
      "alt": ""
    }
  }) : _c('img', {
    attrs: {
      "src": "/static/img/required-icon.svg",
      "alt": ""
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Canal de Venta:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                      " + _vm._s(_vm.orderDataShow.attributes.client.attributes.profile.attributes
    .userable.attributes.store_id === 1 ?
    "Sendi" :
    "Envios") + "\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Servicio:")]), _vm._v(" "), (
    _vm.orderDataShow.attributes.client.attributes.profile.attributes
    .userable.attributes.store_id === 1
  ) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                      " + _vm._s(_vm.orderDataShow.attributes.direct_type === 1 ?
    "Courier" :
    "Shopper") + "\n                    ")]) : _vm._e(), _vm._v(" "), (
    _vm.orderDataShow.attributes.client.attributes.profile.attributes
    .userable.attributes.store_id === 2
  ) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                      " + _vm._s(_vm.orderDataShow.attributes.direct_type === 1 ? "Lite" : "Premium") + "\n                    ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Factura Comercial:")]), _vm._v(" "), (_vm.orderDataShow.attributes.vouchers_usa.length === 0) ? _c('span', {
    staticClass: "details-title-item"
  }, [_c('ul', [_c('li', [_vm._v("Sin Adjunto")]), _vm._v(" "), _c('li', [_c('input', {
    ref: "fileupload",
    attrs: {
      "type": "file",
      "accept": "image/*,.pdf",
      "disabled": _vm.orderDataShow.attributes.status === 10
    },
    on: {
      "change": _vm.factura
    }
  })])])]) : _c('span', {
    staticClass: "details-title-item"
  }, [_c('ul', [_vm._l((_vm.orderDataShow.attributes
    .vouchers_usa), function(invoice, index) {
    return _c('li', {
      key: invoice
    }, [_c('a', {
      attrs: {
        "href": invoice.url,
        "target": "_blank"
      }
    }, [_vm._v("Ver Adjunto - " + _vm._s(index + 1) + "\n                          ")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "cursor": "pointer"
      },
      style: (invoice.status === 0 ? 'color:#DD5385' : 'color:#3BC73B'),
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.statusInvoice(invoice.url, index + 1, invoice.status)
        }
      }
    }, [_vm._v("-\n                            " + _vm._s(invoice.status === 0 ? "(Sin Aprobar)" : "(Aprobado)") + "\n                            -")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.deleteInvoice(invoice.url, index + 1)
        }
      }
    }, [_vm._v("(Eliminar)")])])
  }), _vm._v(" "), _c('li', [_c('input', {
    ref: "fileupload",
    attrs: {
      "type": "file",
      "accept": "image/*,.pdf",
      "disabled": _vm.orderDataShow.attributes.status === 10
    },
    on: {
      "change": _vm.factura
    }
  })])], 2)])])]), _vm._v(" "), (
    _vm.orderDataShow.attributes.client.attributes.profile.attributes
    .userable.attributes.store_id === 1
  ) ? _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Manifiesto:")]), _vm._v(" "), (_vm.orderDataShow.attributes.manifest.length === 0) ? _c('span', {
    staticClass: "details-title-item"
  }, [_c('ul', [_c('li', [_vm._v("Sin Adjunto")]), _vm._v(" "), _c('li', [_c('input', {
    attrs: {
      "type": "file",
      "accept": "image/*,.pdf",
      "disabled": _vm.orderDataShow.attributes.status === 10
    },
    on: {
      "change": _vm.manifiestoFile
    }
  })])])]) : _c('span', {
    staticClass: "details-title-item"
  }, [_c('ul', [_vm._l((_vm.orderDataShow.attributes.manifest), function(invoice, index) {
    return _c('li', {
      key: invoice
    }, [_c('a', {
      attrs: {
        "href": invoice.url,
        "target": "_blank"
      }
    }, [_vm._v("Ver Manifiesto - " + _vm._s(index + 1) + "\n                          ")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "cursor": "pointer"
      },
      style: (invoice.status === 0 ? 'color:#DD5385' : 'color:#3BC73B'),
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.statusManifiesto(invoice.url, index + 1, invoice.status)
        }
      }
    }, [_vm._v("-\n                            " + _vm._s(invoice.status === 0 ? "(Sin Aprobar)" : "(Aprobado)") + "\n                            -")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.deleteManifiesto(invoice.url, index + 1)
        }
      }
    }, [_vm._v("(Eliminar)")])])
  }), _vm._v(" "), _c('li', [_c('input', {
    attrs: {
      "type": "file",
      "accept": "image/*,.pdf",
      "disabled": _vm.orderDataShow.attributes.status === 10
    },
    on: {
      "change": _vm.manifiestoFile
    }
  })])], 2)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Método:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_c('button', {
    staticClass: "button",
    class: _vm.orderDataShow.attributes.courier_type === 1 ?
      'button-success' :
      'button-outline',
    style: (_vm.orderDataShow.attributes.courier_type === 1 ?
      'cursor: not-allowed;' :
      'cursor: pointer;'),
    attrs: {
      "disabled": _vm.orderDataShow.attributes.courier_type === 1 ||
        _vm.orderDataShow.attributes.status === 10
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateOrderInformation('aduana')
      }
    }
  }, [_vm._v("\n                        Aduana\n                        "), (_vm.orderDataShow.attributes.courier_type === 1) ? _c('img', {
    attrs: {
      "src": "/static/img/success.svg",
      "alt": ""
    }
  }) : _c('img', {
    attrs: {
      "src": "/static/img/required-icon.svg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "button",
    class: _vm.orderDataShow.attributes.courier_type === 2 ?
      'button-success' :
      'button-outline',
    staticStyle: {
      "margin-left": "12px"
    },
    style: (_vm.orderDataShow.attributes.courier_type === 2 ?
      'cursor: not-allowed;' :
      'cursor: pointer;'),
    attrs: {
      "disabled": _vm.orderDataShow.attributes.courier_type === 2 ||
        _vm.orderDataShow.attributes.status === 10
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateOrderInformation('pasajero')
      }
    }
  }, [_vm._v("\n                        Pasajero\n                        "), (_vm.orderDataShow.attributes.courier_type === 2) ? _c('img', {
    attrs: {
      "src": "/static/img/success.svg",
      "alt": ""
    }
  }) : _c('img', {
    attrs: {
      "src": "/static/img/required-icon.svg",
      "alt": ""
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Canal:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_c('button', {
    staticClass: "button",
    class: _vm.orderDataShow.attributes.channel === 'A' ?
      'button-success' :
      'button-outline',
    style: (_vm.orderDataShow.attributes.channel === 'A' ?
      'cursor: not-allowed;' :
      'cursor: pointer;'),
    attrs: {
      "disabled": _vm.orderDataShow.attributes.channel === 'A' ||
        _vm.orderDataShow.attributes.status === 10
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateOrderInformation('A')
      }
    }
  }, [_vm._v("\n                        Verde\n                        "), (_vm.orderDataShow.attributes.channel === 'A') ? _c('img', {
    attrs: {
      "src": "/static/img/success.svg",
      "alt": ""
    }
  }) : _c('img', {
    attrs: {
      "src": "/static/img/required-icon.svg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "button",
    class: _vm.orderDataShow.attributes.channel === 'B' ?
      'button-error' :
      'button-outline',
    staticStyle: {
      "margin-left": "12px"
    },
    style: (_vm.orderDataShow.attributes.channel === 'B' ?
      'cursor: not-allowed;' :
      'cursor: pointer;'),
    attrs: {
      "disabled": _vm.orderDataShow.attributes.channel === 'B' ||
        _vm.orderDataShow.attributes.status === 10
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateOrderInformation('B')
      }
    }
  }, [_vm._v("\n                        Rojo\n                        "), (_vm.orderDataShow.attributes.channel === 'B') ? _c('img', {
    attrs: {
      "src": "/static/img/error-icon.svg",
      "alt": ""
    }
  }) : _c('img', {
    attrs: {
      "src": "/static/img/required-icon.svg",
      "alt": ""
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Fecha de creación:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.order_create_date) + "\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Entrega prometida:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.delivery_date) + "\n                    ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "clientInformation2",
      "aria-labelledby": "information2"
    }
  }, [_c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Nombre:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.client.attributes.profile.attributes
    .name) + "\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Apellido:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                      " + _vm._s(_vm.orderDataShow.attributes.client.attributes.profile.attributes
    .surnames) + "\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Documento:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                      " + _vm._s(_vm.orderDataShow.attributes.client.attributes.profile.attributes
    .document_number) + "\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Teléfono:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                      " + _vm._s(_vm.orderDataShow.attributes.client.attributes.profile.attributes
    .cellphone) + "\n                    ")])])]), _vm._v(" "), (_vm.orderDataShow.attributes.client.attributes.address !== null) ? _c('span', [_c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Dirección:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                        " + _vm._s(_vm.orderDataShow.attributes.client.attributes.address.address) + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Piso u Oficina:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.client.attributes.address.inner) + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Referencia:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.client.attributes.address.reference) + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Departamento:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.client.attributes.address.department) + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Provincia:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.client.attributes.address.city) + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Distrito:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.client.attributes.address.district) + "\n                      ")])])])]) : _c('span', [_vm._m(14)]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Correo electrónico:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                      " + _vm._s(_vm.orderDataShow.attributes.client.attributes.profile.attributes
    .userable.attributes.email) + "\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Status:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                      " + _vm._s(_vm.orderDataShow.attributes.client.attributes.validation.verified ?
    "Verificado" :
    "No Verificado") + "\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("DNI anterior:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.client.attributes
    .document_face_state === 3 ?
    "Verificado " :
    "No Verificado ") + "\n                      "), (
    _vm.orderDataShow.attributes.client.attributes
    .document_face_url !== null
  ) ? _c('a', {
    attrs: {
      "href": _vm.orderDataShow.attributes.client.attributes.document_face_url,
      "target": "Blank"
    }
  }, [_vm._v("\n                        - Ver imagen")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("DNI posterior:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.client.attributes
    .document_seal_state === 3 ?
    "Verificado " :
    "No Verificado ") + "\n                      "), (
    _vm.orderDataShow.attributes.client.attributes
    .document_seal_url !== null
  ) ? _c('a', {
    attrs: {
      "href": _vm.orderDataShow.attributes.client.attributes.document_seal_url,
      "target": "Blank"
    }
  }, [_vm._v("\n                        - Ver imagen")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Código de Usuario:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                      " + _vm._s(_vm.orderDataShow.attributes.client.attributes.profile.attributes
    .userable.client_code) + "\n                      -\n                      "), _c('router-link', {
    attrs: {
      "to": {
        name: 'UserDetail',
        params: {
          idUser: _vm.orderDataShow.attributes.client.id
        },
      },
      "target": "_blank"
    }
  }, [_vm._v("Ver perfil")])], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "clientInformation3",
      "aria-labelledby": "information3"
    }
  }, [(_vm.orderDataShow.attributes.shipping_address) ? _c('span', [_c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Tipo:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.at_office_flag === 1 ?
    "Oficina" :
    "Domicilio") + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Nombre:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                        " + _vm._s(_vm.orderDataShow.attributes.shipping_address.attributes
    .owner_name) + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Apellido:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                        " + _vm._s(_vm.orderDataShow.attributes.shipping_address.attributes
    .owner_lastname) + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Documento:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                        " + _vm._s(_vm.orderDataShow.attributes.shipping_address.attributes
    .owner_document_number) + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Teléfono:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                        " + _vm._s(_vm.orderDataShow.attributes.shipping_address.attributes
    .telephone_number))])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Dirección:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.shipping_address.attributes.address) + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(" Piso u Oficina:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.shipping_address.attributes.inner) + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Referencia:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.shipping_address.attributes.reference) + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Departamento:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.shipping_address.attributes
    .department) + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Provincia:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.shipping_address.attributes.city) + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Distrito:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                        " + _vm._s(_vm.orderDataShow.attributes.shipping_address.attributes.district) + "\n                      ")])])])]) : _c('span', [_c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Tipo:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.at_office_flag === 1 ?
    "Oficina" :
    "Domicilio") + "\n                      ")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "clientInformation4",
      "aria-labelledby": "information4"
    }
  }, [_c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item",
    style: (_vm.orderDataShow.attributes.direct_type === 1 ? 'color:red;' : '')
  }, [_vm._v("Precio del producto:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item",
    style: (_vm.orderDataShow.attributes.direct_type === 1 ? 'color:red;' : '')
  }, [_vm._v("USD\n                      " + _vm._s((
    _vm.orderDataShow.attributes.real_price *
    _vm.orderDataShow.attributes.product_specimens
  ).toFixed(2)) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item",
    style: (_vm.orderDataShow.attributes.direct_type === 1 ? 'color:red;' : '')
  }, [_vm._v("Shipping:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item",
    style: (_vm.orderDataShow.attributes.direct_type === 1 ? 'color:red;' : '')
  }, [_vm._v("USD " + _vm._s(_vm.orderDataShow.attributes.real_shipping.toFixed(2)) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item",
    style: (_vm.orderDataShow.attributes.direct_type === 1 ? 'color:red;' : '')
  }, [_vm._v("Tax:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item",
    style: (_vm.orderDataShow.attributes.direct_type === 1 ? 'color:red;' : '')
  }, [_vm._v("USD " + _vm._s(_vm.orderDataShow.attributes.real_tax.toFixed(2)) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Seguro/Warehouse:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("USD " + _vm._s(_vm.orderDataShow.attributes.warehouse) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Flete/Millas de vuelo:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("USD " + _vm._s(_vm.orderDataShow.attributes.flete_cost.toFixed(2)) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Ad valorem/Recompensa:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("USD " + _vm._s(_vm.orderDataShow.attributes.ad_valorem.toFixed(2)) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Igv/Recompensa:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("USD " + _vm._s(_vm.orderDataShow.attributes.igv.toFixed(2)) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Ipm/Recompensa:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("USD " + _vm._s(_vm.orderDataShow.attributes.ipm.toFixed(2)) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Tramite aduanero/Margen de servicio:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("USD " + _vm._s(_vm.orderDataShow.attributes.tramite_aduanero.toFixed(2)) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Envío nacional:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("USD " + _vm._s(_vm.orderDataShow.attributes.national_shipping.toFixed(2)) + "\n                    ")])]), _vm._v(" "), (
    _vm.orderDataShow.attributes.coupon_discount !== null &&
    _vm.orderDataShow.attributes.coupon_id !== null
  ) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Cupones:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("USD " + _vm._s(_vm.orderDataShow.attributes.coupon_discount) + " - \"" + _vm._s(_vm.orderDataShow.attributes.coupon.attributes.code) + "\"\n                    ")])]) : _vm._e(), _vm._v(" "), (
    _vm.orderDataShow.attributes.coupon_discount !== null &&
    _vm.orderDataShow.attributes.coupon_id === null
  ) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Campaña: ")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("USD " + _vm._s(_vm.orderDataShow.attributes.coupon_discount) + " - \"" + _vm._s(_vm.orderDataShow.attributes.campaign.attributes.code) + "\"\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.balance_discount !== null) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Balance:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("USD " + _vm._s(_vm.orderDataShow.attributes.balance_discount) + "\n                    ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Servicios Extras :")]), _vm._v(" "), (_vm.orderDataShow.attributes.services.length === 0) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                      Sin servicios extras\n                    ")]) : _c('span', {
    staticClass: "details-title-item"
  }, [_c('ul', _vm._l((_vm.orderDataShow.attributes.services), function(data) {
    return _c('li', {
      key: data
    }, [_vm._v("\n                          " + _vm._s(data.name) + " - USD " + _vm._s(data.pivot.amount) + "\n                        ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Total:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("USD\n                      " + _vm._s(_vm.orderDataShow.attributes.new_total_cost === null ?
    _vm.orderDataShow.attributes.total_cost.toFixed(2) :
    _vm.orderDataShow.attributes.new_total_cost.toFixed(2)) + "\n                    ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_vm._m(17), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "clientInformation5",
      "aria-labelledby": "information5"
    }
  }, [_c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Moneda:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.currency) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Monto Abonado:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.currency) + "\n                      " + _vm._s((
    _vm.orderDataShow.attributes.total_cost *
    _vm.orderDataShow.attributes.exchange
  ).toFixed(2)) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Status de pago:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, _vm._l((_vm.statusPayment), function(status) {
    return _c('span', {
      key: status
    }, [(_vm.orderDataShow.attributes.payed === status.id) ? _c('span', [_vm._v("\n                          " + _vm._s(status.text) + "\n                        ")]) : _vm._e()])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Método de pago:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [(_vm.orderDataShow.attributes.payment_method_flag === 4) ? _c('span', {
    staticClass: "details-title-item",
    staticStyle: {
      "color": "#212529"
    }
  }, [_vm._v("Pago Efectivo - " + _vm._s(_vm.orderDataShow.attributes.atm_payment.payment_code) + "\n                      ")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.payment_method_flag === 6) ? _c('span', {
    staticClass: "details-title-item",
    staticStyle: {
      "color": "#212529"
    }
  }, [_vm._v("Saldo\n                      ")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.payment_method_flag === 5) ? _c('span', {
    staticClass: "details-title-item",
    staticStyle: {
      "color": "#212529"
    }
  }, [_vm._v("Transferencia\n                      ")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.payment_method_flag === 2) ? _c('span', {
    staticClass: "details-title-item",
    staticStyle: {
      "color": "#212529"
    }
  }, [_vm._v("Paypal\n                      ")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.payment_method_flag === 3) ? _c('span', {
    staticClass: "details-title-item",
    staticStyle: {
      "color": "#212529"
    }
  }, [_vm._v("Tarjeta\n                      ")]) : _vm._e()])]), _vm._v(" "), (_vm.orderDataShow.attributes.payment_method_flag === 4) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Código de referencia:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                      " + _vm._s(_vm.orderDataShow.attributes.atm_payment.mp_payment_id ?
    _vm.orderDataShow.attributes.atm_payment.mp_payment_id :
    "Sin código") + "\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.payment_method_flag === 6) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Código de referencia:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                      Realizo el pago con su saldo\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.payment_method_flag === 5) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Código de referencia:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_c('ul', {
    staticClass: "listStyle",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('ol', [_vm._v("\n                          " + _vm._s(_vm.orderDataShow.attributes.payment_code ?
    _vm.orderDataShow.attributes.payment_code :
    "Sin código") + "\n                        ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('ol', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.codigoTransferencia),
      expression: "codigoTransferencia"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Código de referencia",
      "disabled": _vm.orderDataShow.attributes.status === 10
    },
    domProps: {
      "value": (_vm.codigoTransferencia)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.codigoTransferencia = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('ol', [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.orderDataShow.attributes.status === 10
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.sendVaucherComprobante(1)
      }
    }
  }, [_vm._v("\n                            Cambiar\n                          ")])])])])]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.payment_method_flag === 2) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Código de referencia:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                      " + _vm._s(_vm.orderDataShow.attributes.paypalPayment.attributes
    .paypal_authorization_id ?
    _vm.orderDataShow.attributes.paypalPayment.attributes
    .paypal_authorization_id :
    "Sin código") + "\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.payment_method_flag === 3) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Código de referencia:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                      " + _vm._s(_vm.orderDataShow.attributes.mercadopagoPayment.attributes
    .payment_id ?
    _vm.orderDataShow.attributes.mercadopagoPayment.attributes
    .payment_id :
    "Sin código") + "\n                    ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Comprobante de pago:")]), _vm._v(" "), (_vm.orderDataShow.attributes.voucher_link === null) ? _c('span', {
    staticClass: "details-title-item"
  }, [_c('ul', {
    staticClass: "listStyle",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('ol', [_vm._v("\n                          Sin comprobante\n                        ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('ol', [_c('input', {
    ref: "fileuploadComprobante",
    attrs: {
      "type": "file",
      "accept": "image/*,.pdf",
      "disabled": _vm.orderDataShow.attributes.status === 10
    },
    on: {
      "change": _vm.comprobante
    }
  })])])]) : _c('span', {
    staticClass: "details-title-item"
  }, [_c('ul', {
    staticClass: "listStyle",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('ol', [_c('a', {
    attrs: {
      "href": _vm.orderDataShow.attributes.voucher_link,
      "target": "_blank"
    }
  }, [_vm._v("Ver comprobante")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('ol', [_c('input', {
    ref: "fileuploadComprobante",
    attrs: {
      "type": "file",
      "accept": "image/*,.pdf",
      "disabled": _vm.orderDataShow.attributes.status === 10
    },
    on: {
      "change": _vm.comprobante
    }
  })])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_vm._m(18), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "clientInformation6",
      "aria-labelledby": "information6"
    }
  }, [_c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("N° de tracking:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.system_tracking_number) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Status del tracking:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                      " + _vm._s(_vm.orderDataShow.attributes.order_tracking_details[
    _vm.orderDataShow.attributes.order_tracking_details.length - 1
  ].attributes.status) + "\n                      -\n                      "), _vm._l((_vm.statusTracking), function(tracking) {
    return _c('span', {
      key: tracking
    }, [(
      tracking.id ===
      _vm.orderDataShow.attributes.order_tracking_details[
        _vm.orderDataShow.attributes.order_tracking_details.length - 1
      ].attributes.status
    ) ? _c('span', [_vm._v("\n                          " + _vm._s(tracking.text))]) : _vm._e()])
  })], 2)])])])])])]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.type !== 2) ? _c('span', [_c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_vm._m(19), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseclient",
      "aria-labelledby": "headingclient"
    }
  }, [_c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [(
    _vm.orderDataShow.attributes.is_from_grabr_flag &&
    _vm.orderDataShow.attributes.grabrOrder.attributes
    .client_grabr_id != null
  ) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("ID de cliente:")]) : _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Código:")]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.customer_id) + "\n                    ")]) : (
    (_vm.orderDataShow.attributes.is_from_grabr_flag &&
      _vm.orderDataShow.attributes.grabrOrder.attributes
      .client_grabr_id == null) ||
    _vm.orderDataShow.attributes.is_from_linio_flag
  ) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.external_client_dni != null ?
    _vm.orderDataShow.attributes.external_client_dni :
    "No definido") + "\n                    ")]) : (
    !_vm.orderDataShow.attributes.is_from_grabr_flag &&
    !_vm.orderDataShow.attributes.is_from_linio_flag &&
    !_vm.orderDataShow.attributes.is_from_meli_flag
  ) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                      " + _vm._s(_vm.orderDataShow.attributes.client.attributes.profile.attributes
    .document_number))]) : (
    _vm.orderDataShow.attributes.is_from_grabr_flag &&
    _vm.orderDataShow.attributes.grabrOrder.attributes
    .client_grabr_id != null
  ) ? _c('span', {
    staticClass: "details-title-item"
  }, [_c('a', {
    attrs: {
      "href": 'https://grabr.io/es/users/' +
        _vm.orderDataShow.attributes.grabrOrder.attributes.client_grabr_id,
      "target": "_blank"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.orderDataShow.attributes.grabrOrder.attributes.client_grabr_id) + "\n                      ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Nombres y apellidos:")]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_grabr_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.external_client_name))]) : (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.linioOrder.attributes
    .customer_first_name +
    " " +
    _vm.orderDataShow.attributes.linioOrder.attributes
    .customer_last_name))]) : (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes
    .customer_first_name +
    " " +
    _vm.orderDataShow.attributes.meliOrder.attributes.customer_last_name))]) : _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.client.attributes.profile.attributes
    .name +
    " " +
    _vm.orderDataShow.attributes.client.attributes.profile.attributes
    .surnames))])]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Nickname:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.customer_nickname))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Número telefónico:")]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.customer_phone))]) : (
    _vm.orderDataShow.attributes.is_from_grabr_flag ||
    _vm.orderDataShow.attributes.is_from_linio_flag ||
    _vm.orderDataShow.attributes.is_from_meli_flag
  ) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                      " + _vm._s(_vm.orderDataShow.attributes.external_client_cellphone != null ?
    _vm.orderDataShow.attributes.external_client_cellphone :
    "No definido") + "\n                    ")]) : _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.client.attributes.profile.attributes
    .cellphone))])])])])])]), _vm._v(" "), (
    _vm.orderDataShow.attributes.is_from_linio_flag ||
    _vm.orderDataShow.attributes.is_from_meli_flag
  ) ? _c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_vm._m(20), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseshipping",
      "aria-labelledby": "headingshipping"
    }
  }, [(_vm.orderDataShow.attributes.hasshipping) ? _c('div', {
    staticClass: "details-content-info"
  }, [(_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Código de envío: ")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.shipping_id))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Dirección 1: ")]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes
    .shipping_address != null ?
    _vm.orderDataShow.attributes.meliOrder.attributes
    .shipping_address :
    "No definido"))]) : (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.linioOrder.attributes
    .shipping_address != null ?
    _vm.orderDataShow.attributes.linioOrder.attributes
    .shipping_address :
    "No definido"))]) : _vm._e()]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Dirección 2: ")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.shipping_comment !=
    null ?
    _vm.orderDataShow.attributes.meliOrder.attributes.shipping_comment :
    "No definido"))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Distrito: ")]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes
    .shipping_neighborhood != null ?
    _vm.orderDataShow.attributes.meliOrder.attributes
    .shipping_neighborhood :
    "No definido"))]) : (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.linioOrder.attributes
    .shipping_neighborhood != null ?
    _vm.orderDataShow.attributes.linioOrder.attributes
    .shipping_neighborhood :
    "No definido"))]) : _vm._e()]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Ciudad: ")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.shipping_city !=
    null ?
    _vm.orderDataShow.attributes.meliOrder.attributes.shipping_city :
    "No definido"))])]) : _vm._e()]) : _c('div', {
    staticClass: "details-content-info"
  }, [_vm._m(21)])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_vm._m(22), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseorder",
      "aria-labelledby": "headingorder"
    }
  }, [_c('div', {
    staticClass: "details-content-info"
  }, [(_vm.orderDataShow.attributes.is_from_grabr_flag) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("ID de chat en Grabr:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.is_from_grabr_flag ?
    _vm.orderDataShow.attributes.grabrOrder.attributes.grabr_chat_link :
    ""))])]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_grabr_flag) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Sku Grabr:")]), _vm._v(" "), (_vm.orderDataShow.attributes.sku != null) ? _c('a', {
    attrs: {
      "href": _vm.orderDataShow.attributes.linksku,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('span', {
    directives: [{
      name: "b-popover",
      rawName: "v-b-popover.hover.top",
      value: ('Código SKU'),
      expression: "'Código SKU'",
      modifiers: {
        "hover": true,
        "top": true
      }
    }],
    staticClass: "code-order grabr-code enlace color",
    attrs: {
      "id": "order-code"
    }
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.grabrOrder.attributes
    .grabr_purchase_link !== null ?
    _vm.orderDataShow.attributes.grabrOrder.attributes
    .grabr_purchase_link :
    "No definido"))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Sku Linio:")]), _vm._v(" "), (_vm.orderDataShow.attributes.sku != null) ? _c('a', {
    attrs: {
      "href": _vm.orderDataShow.attributes.linksku,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('span', {
    directives: [{
      name: "b-popover",
      rawName: "v-b-popover.hover.top",
      value: ('Código SKU'),
      expression: "'Código SKU'",
      modifiers: {
        "hover": true,
        "top": true
      }
    }],
    staticClass: "code-order grabr-code enlace color",
    attrs: {
      "id": "order-code"
    }
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.linioOrder.attributes
    .linio_purchase_link !== null ?
    _vm.orderDataShow.attributes.linioOrder.attributes
    .linio_purchase_link :
    "No definido"))])]) : _vm._e()]) : (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Sku Mercado Libre:")]), _vm._v(" "), (_vm.orderDataShow.attributes.sku != null) ? _c('a', {
    attrs: {
      "href": _vm.orderDataShow.attributes.linksku,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('span', {
    directives: [{
      name: "b-popover",
      rawName: "v-b-popover.hover.top",
      value: ('Código SKU'),
      expression: "'Código SKU'",
      modifiers: {
        "hover": true,
        "top": true
      }
    }],
    staticClass: "code-order grabr-code enlace color",
    attrs: {
      "id": "order-code"
    }
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.seller_sku !==
    null ?
    _vm.orderDataShow.attributes.meliOrder.attributes.seller_sku :
    "No de finido"))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Link de compra final:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_c('a', {
    attrs: {
      "href": _vm.orderDataShow.attributes.real_purchase_link !== null ?
        _vm.orderDataShow.attributes.real_purchase_link :
        'No definido',
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.real_purchase_link !== null ?
    _vm.orderDataShow.attributes.real_purchase_link :
    "No definido"))])])]), _vm._v(" "), (
    _vm.orderDataShow.attributes.is_from_grabr_flag &&
    _vm.orderDataShow.attributes.grabrOrder.attributes.travel_number
  ) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("ID de viaje en Grabr:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_c('a', {
    attrs: {
      "href": 'https://grabr.io/es/trips/' +
        _vm.orderDataShow.attributes.grabrOrder.attributes.travel_number,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.grabrOrder.attributes.travel_number))])])]) : _vm._e(), _vm._v(" "), (
    _vm.orderDataShow.attributes.is_from_grabr_flag &&
    _vm.orderDataShow.attributes.grabrOrder.attributes.grabr_account
  ) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Cuenta de Grabr:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.grabrOrder.attributes.grabr_account))])]) : (
    _vm.orderDataShow.attributes.is_from_linio_flag &&
    _vm.orderDataShow.attributes.linioOrder.attributes.linio_account
  ) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Cuenta de Linio:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.linioOrder.attributes.linio_account))])]) : (
    _vm.orderDataShow.attributes.is_from_meli_flag &&
    _vm.orderDataShow.attributes.meliOrder.attributes.meli_account
  ) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Cuenta de Mercado Libre:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.meli_account))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Ciudad de origen:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.origin != undefined ?
    _vm.orderDataShow.attributes.origin.attributes.name :
    "No definido (*)"))])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Ciudad de destino:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.destination != undefined ?
    _vm.orderDataShow.attributes.destination.attributes.name :
    "No definido (*)"))])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Fecha de llegada al origen:")]), _vm._v(" "), (
    _vm.orderDataShow.attributes.promised_origin_arrival_date != null
  ) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm._f("spanishDate")(_vm.orderDataShow.attributes.promised_origin_arrival_date)))]) : _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("No definido")])]), _vm._v(" "), (_vm.orderDataShow.attributes.real_origin_arrival_date != null) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Fecha real de llegada al origen:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm._f("spanishDate")(_vm.orderDataShow.attributes.real_origin_arrival_date)))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Entrega prometida:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm._f("spanishDate")(_vm.orderDataShow.attributes.promised_delivery_date)))])]), _vm._v(" "), (_vm.orderDataShow.attributes.real_delivery_date != null) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Fecha real de llegada al cliente:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm._f("spanishDate")(_vm.orderDataShow.attributes.real_delivery_date)))])]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.carrier_name != null) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Transportista:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.carrier_name))])]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.shopping_order_number != null) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Número de compra:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.shopping_order_number))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Código de tracking:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.tracking_number !== null ?
    _vm.orderDataShow.attributes.tracking_number :
    "No definido"))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_vm._m(23), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapsePago",
      "aria-labelledby": "headingclient"
    }
  }, [_c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Fecha de aprobación:")]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes
    .payment_date_approved) + "\n                    ")]) : (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.linioOrder.attributes.linio_offer_date) + "\n                    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Método de pago:")]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.payment_method) + "\n                    ")]) : (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.linioOrder.attributes.payment_method) + "\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.payment_method_flag === 4) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Pago Efectivo - " + _vm._s(_vm.orderDataShow.attributes.atm_payment.payment_code) + "\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.payment_method_flag === 6) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Saldo\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.payment_method_flag === 5) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Transferencia\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.payment_method_flag === 1) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Paypal\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.payment_method_flag === 3) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Tarjeta\n                    ")]) : _vm._e()]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Tipo de pago:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.payment_type) + "\n                    ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Monto de pago:")]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("S/\n                      " + _vm._s(_vm.orderDataShow.attributes.meliOrder.attributes.meli_price) + "\n                    ")]) : (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("S/\n                      " + _vm._s(_vm.orderDataShow.attributes.linioOrder.attributes.linio_price) + "\n                    ")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.currency === "USD" ? "$ " : "S/ ") + "\n                      " + _vm._s((
    _vm.orderDataShow.attributes.total_cost *
    _vm.orderDataShow.attributes.exchange
  ).toFixed(2)) + "\n                    ")])])])])])])]) : _vm._e(), _vm._v(" "), _vm._m(24), _vm._v(" "), (true) ? _c('div', {
    staticClass: "details-content"
  }, [(
    !(
      _vm.orderDataShow.attributes.cancelled == 1 &&
      _vm.orderDataShow.attributes.status == 10
    )
  ) ? _c('div', {
    staticClass: "details-content-comments"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentContent),
      expression: "currentContent"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "aria-describedby": "email",
      "maxlength": 1000,
      "disabled": !_vm.createCommentFlag,
      "rows": "1",
      "placeholder": "Deja tu comentario..."
    },
    domProps: {
      "value": (_vm.currentContent)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentContent = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [(_vm.currentContent.length != 0) ? _c('div', {
    staticClass: "btn-wrap"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block btn-round",
    attrs: {
      "disabled": _vm.orderDataShow.attributes.status === 10
    },
    on: {
      "click": _vm.createComment
    }
  }, [_vm._v("\n                  Enviar\n                ")])]) : _c('div', {
    staticClass: "btn-wrap"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block btn-round",
    attrs: {
      "disabled": _vm.orderDataShow.attributes.status === 10
    }
  }, [_vm._v("\n                  Enviar\n                ")])])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.comments), function(comment, index) {
    return _c('comment-component', {
      key: index,
      attrs: {
        "comment": comment,
        "orderCancelledFlag": _vm.orderDataShow.attributes.status == 10 &&
          _vm.orderDataShow.attributes.cancelled == 1,
        "order": _vm.orderDataShow
      },
      on: {
        "in-edition": _vm.disableEditComments,
        "cancel-edition": _vm.enableEditComments,
        "display-comments": _vm.displayComments,
        "comment-deleted": _vm.displayComments
      }
    })
  })], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "nm n-2",
    attrs: {
      "id": "fixedElement"
    }
  }, [_c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    staticClass: "details-title-container"
  }, [_c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_vm._m(25), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm.noGravado))])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_vm._m(26), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm.gravado))])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block details-summary-item"
  }, [_vm._m(27), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("$ " + _vm._s(_vm.totalIgv))])])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    staticClass: "details-title-container"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Status del Pago :")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pagosStatus),
      expression: "pagosStatus"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.orderDataShow.attributes.status === 10
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.pagosStatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changeStatusPayment(_vm.pagosStatus)
      }]
    }
  }, _vm._l((_vm.statusPayment), function(status) {
    return _c('option', {
      key: status,
      domProps: {
        "value": status.id,
        "selected": _vm.orderDataShow.attributes.payed === status.id
      }
    }, [_vm._v("\n                    " + _vm._s(status.text) + "\n                  ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Status del Tracking :")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trakingStatus),
      expression: "trakingStatus"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.pagosStatus !== 3 || _vm.orderDataShow.attributes.status === 10
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.trakingStatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changeStatusTracking(_vm.trakingStatus)
      }]
    }
  }, _vm._l((_vm.statusTracking), function(tracking) {
    return _c('option', {
      key: tracking,
      domProps: {
        "value": tracking.id,
        "selected": _vm.orderDataShow.attributes.order_tracking_details[
          _vm.orderDataShow.attributes.order_tracking_details.length - 1
        ].attributes.status === tracking.id
      }
    }, [_vm._v("\n                    " + _vm._s(tracking.text) + "\n                  ")])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_vm._m(28), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "clientInformationD1",
      "aria-labelledby": "informationD1"
    }
  }, [_vm._m(29), _vm._v(" "), _vm._m(30), _vm._v(" "), _vm._m(31), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Calcular:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.orderDataShow.attributes.status === 10,
      "type": "button"
    }
  }, [_vm._v("\n                      Calcular\n                    ")])])])])])])]), _vm._v(" "), [(
    _vm.servicioReturn &&
    (_vm.orderDataShow.attributes.order_tracking_details[
        _vm.orderDataShow.attributes.order_tracking_details.length - 1
      ].attributes.status === 9 ||
      _vm.orderDataShow.attributes.order_tracking_details[
        _vm.orderDataShow.attributes.order_tracking_details.length - 1
      ].attributes.status === 10) &&
    _vm.orderDataShow.attributes.payed === 3
  ) ? _c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "serviioReturn",
      "data-toggle": "collapse",
      "data-target": "#clientServicioReturn",
      "aria-expanded": "false",
      "aria-controls": "clientServicioReturn"
    }
  }, [_c('span', [_vm._v("Servicio Return")]), _vm._v(" "), (_vm.servicioReturn && _vm.orderDataShow.attributes.payed === 3) ? _c('span', {
    staticClass: "phil-success"
  }, [_vm._v("Pagado")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "clientServicioReturn",
      "aria-labelledby": "serviioReturn"
    }
  }, [_c('div', {
    staticClass: "details-content-info"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Adjunto:")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.fileReturn
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('ul', _vm._l((_vm.orderDataShow.attributes.serviceReturn), function(data, index) {
    return _c('li', {
      key: data
    }, [_c('a', {
      attrs: {
        "href": data.url_return,
        "target": "_Blank"
      }
    }, [_vm._v("\n                        " + _vm._s(index === 0 ? "Etiqueta de devolución" : "Evidencia") + "\n                        "), (index !== 0) ? _c('span', [_vm._v("\n                          -\n                          " + _vm._s(index) + "\n                        ")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "red"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.deleteFileReturn(data)
        }
      }
    }, [_vm._v("Eliminar")])])])
  }), 0)])])])]) : _c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "serviioReturn",
      "data-toggle": "collapse",
      "data-target": "#clientServicioReturn",
      "aria-expanded": "false",
      "aria-controls": "clientServicioReturn"
    }
  }, [_c('span', [_vm._v("Servicio Return")]), _vm._v(" "), (_vm.servicioReturn && _vm.orderDataShow.attributes.payed === 3) ? _c('span', {
    staticClass: "phil-success"
  }, [_vm._v("Pagado")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "clientServicioReturn",
      "aria-labelledby": "serviioReturn"
    }
  }, [_vm._m(32), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('ul', _vm._l((_vm.orderDataShow.attributes.serviceReturn), function(data, index) {
    return _c('li', {
      key: data
    }, [_c('a', {
      attrs: {
        "href": data.url_return,
        "target": "_Blank"
      }
    }, [_vm._v("\n                        " + _vm._s(index === 0 ? "Etiqueta de devolución" : "Evidencia") + "\n                        "), (index !== 0) ? _c('span', [_vm._v("\n                          -\n                          " + _vm._s(index) + "\n                        ")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "red"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.deleteFileReturn(data)
        }
      }
    }, [_vm._v("Eliminar")])])])
  }), 0)])])])])], _vm._v(" "), [(_vm.servicioCheckup) ? _c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "servicioCheckout",
      "data-toggle": "collapse",
      "data-target": "#clientServicioCheckout",
      "aria-expanded": "false",
      "aria-controls": "clientServicioCheckout"
    }
  }, [_c('span', [_vm._v("Servicio Checkup")]), _vm._v(" "), (_vm.servicioCheckup && _vm.orderDataShow.attributes.payed === 3) ? _c('span', {
    staticClass: "phil-success"
  }, [_vm._v("Pagado")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })]), _vm._v(" "), _vm._m(33)])]) : _vm._e()], _vm._v(" "), [(_vm.servicioReview && _vm.orderDataShow.attributes.payed === 3) ? _c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "servicioReview",
      "data-toggle": "collapse",
      "data-target": "#clientServicioReview",
      "aria-expanded": "false",
      "aria-controls": "clientServicioReview"
    }
  }, [_c('span', [_vm._v("Servicio Review")]), _vm._v(" "), (_vm.servicioReview && _vm.orderDataShow.attributes.payed === 3) ? _c('span', {
    staticClass: "phil-success"
  }, [_vm._v("Pagado")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "clientServicioReview",
      "aria-labelledby": "servicioReview"
    }
  }, [_c('div', {
    staticClass: "details-content-info"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Review:")]), _vm._v(" "), _vm._l((_vm.orderDataShow.attributes.Reviews), function(reviewD) {
    return _c('span', {
      key: reviewD
    }, [_vm._v("\n                    " + _vm._s(reviewD.from_admin === 0 ? reviewD.mesagge_review : ""))])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Respuesta:")]), _vm._v(" "), _vm._l((_vm.orderDataShow.attributes.Reviews), function(reviewD) {
    return _c('span', {
      key: reviewD
    }, [(reviewD.from_admin !== 0) ? _c('span', [_vm._v("\n                      . " + _vm._s(reviewD.mesagge_review) + "\n                      "), (reviewD.url_review) ? _c('span', [_vm._v("\n                        - "), _c('a', {
      attrs: {
        "href": reviewD.url_review,
        "target": "_Blank"
      }
    }, [_vm._v("Documento")])]) : _vm._e(), _vm._v(" "), _c('br')]) : _vm._e()])
  }), _vm._v(" "), _c('span', {
    staticClass: "details-title-item",
    staticStyle: {
      "margin-top": "25px"
    }
  }, [_vm._v("Responder:")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.RespuestaReview.apply(null, arguments)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formReviewSer.respuesta),
      expression: "formReviewSer.respuesta"
    }],
    staticClass: "form-control",
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "type": "text",
      "placeholder": "Ingresar respuesta",
      "required": ""
    },
    domProps: {
      "value": (_vm.formReviewSer.respuesta)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formReviewSer, "respuesta", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.subirArchivoReview
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "form-control btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                      Mandar respuesta\n                    ")])])], 2)])])]) : _c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "servicioReview",
      "data-toggle": "collapse",
      "data-target": "#clientServicioReview",
      "aria-expanded": "false",
      "aria-controls": "clientServicioReview"
    }
  }, [_c('span', [_vm._v("Servicio Review")]), _vm._v(" "), (_vm.servicioReview && _vm.orderDataShow.attributes.payed === 3) ? _c('span', {
    staticClass: "phil-success"
  }, [_vm._v("Pagado")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "clientServicioReview",
      "aria-labelledby": "servicioReview"
    }
  }, [_c('div', {
    staticClass: "details-content-info"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Review:")]), _vm._v(" "), _vm._l((_vm.orderDataShow.attributes.Reviews), function(reviewD) {
    return _c('span', {
      key: reviewD
    }, [_vm._v("\n                    " + _vm._s(reviewD.from_admin === 0 ? reviewD.mesagge_review : ""))])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Respuesta:")]), _vm._v(" "), _vm._l((_vm.orderDataShow.attributes.Reviews), function(reviewD) {
    return _c('span', {
      key: reviewD
    }, [(reviewD.from_admin !== 0) ? _c('span', [_vm._v("\n                      . " + _vm._s(reviewD.mesagge_review) + "\n                      "), (reviewD.url_review) ? _c('span', [_vm._v("\n                        - "), _c('a', {
      attrs: {
        "href": reviewD.url_review,
        "target": "_Blank"
      }
    }, [_vm._v("Documento")])]) : _vm._e(), _vm._v(" "), _c('br')]) : _vm._e()])
  }), _vm._v(" "), _c('span', {
    staticClass: "details-title-item",
    staticStyle: {
      "margin-top": "25px"
    }
  }, [_vm._v("Responder:")]), _vm._v(" "), _vm._m(34)], 2)])])])], _vm._v(" "), _c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_vm._m(35), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "clientOrderReasign",
      "aria-labelledby": "Reasignar orden"
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.getUserSearch.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group mt-3 w-100"
  }, [_c('label', [_vm._v("ID del usuario")]), _vm._v(" "), _c('div', {
    staticClass: "form-client"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.dni),
      expression: "search.dni"
    }],
    staticClass: "form-control d-block w-100 mb-3",
    attrs: {
      "type": "text",
      "maxlength": "8",
      "required": ""
    },
    domProps: {
      "value": (_vm.search.dni)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "dni", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-append w-100",
    attrs: {
      "id": "button-addon4"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg btn-edit btn-subir d-block w-100",
    attrs: {
      "disabled": _vm.orderDataShow.attributes.status === 10,
      "type": "submit"
    }
  }, [_vm._v("\n                          Validar cliente\n                        ")])])])])]), _vm._v(" "), (_vm.search.result !== null) ? _c('div', [_c('p', {
    staticClass: "mx-0"
  }, [_vm._v("Resultado:")]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "d-flex align-items-center mb-3",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changeUserOrder.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-user-circle mr-3",
    staticStyle: {
      "font-size": "28px"
    }
  }), _vm._v(" "), _c('span', [_vm._v("\n                        " + _vm._s(_vm.search.result.attributes.profile.attributes.name +
    " " +
    _vm.search.result.attributes.profile.attributes.surnames))])])])]) : _vm._e(), _vm._v(" "), (_vm.search.error) ? _c('div', [_vm._v("Cliente no existe en el sistema")]) : _vm._e()]), _vm._v(" "), (_vm.historyUser.length !== 0) ? _c('span', _vm._l((_vm.historyUser), function(history) {
    return _c('div', {
      key: history.id,
      staticClass: "mt-4",
      attrs: {
        "id": "accordion"
      }
    }, [_c('div', {
      staticClass: "details-content-title collapsed pb-2 mb-3",
      staticStyle: {
        "border-bottom": "1px solid #ccc"
      },
      attrs: {
        "id": 'informationHistory' + history.id,
        "data-toggle": "collapse",
        "data-target": '#clientInformationHistory' + history.id,
        "aria-expanded": "false",
        "aria-controls": 'clientInformationHistory' + history.id
      }
    }, [_c('article', {
      staticClass: "p-0"
    }, [_c('p', {
      staticClass: "m-0 mb-2",
      staticStyle: {
        "font-size": "14px"
      }
    }, [_vm._v("\n                        Old Client Code:" + _vm._s(history.oldClientCode) + " -\n                        " + _vm._s(history.created_at) + "\n                      ")])]), _vm._v(" "), _c('div', {
      staticClass: "details-text up-arrow"
    })]), _vm._v(" "), _c('div', {
      staticClass: "collapse",
      attrs: {
        "id": 'clientInformationHistory' + history.id,
        "aria-labelledby": 'informationHistory' + history.id
      }
    }, [_c('span', [_c('div', {}, [_c('div', {
      staticClass: "cursorNot details-info-viajero mx-2"
    }, [_c('span', {}, [_vm._v("idOrder:")]), _vm._v(" "), _c('span', {}, [_vm._v(_vm._s(history.idOrder))])])])]), _vm._v(" "), _c('span', [_c('div', {
      staticClass: "details-content-info"
    }, [_c('div', {
      staticClass: "cursorPointer details-info-viajero mx-2"
    }, [_c('span', {}, [_vm._v("oldClientCode:")]), _vm._v(" "), _c('span', {}, [_c('router-link', {
      attrs: {
        "to": {
          name: 'UserDetail',
          params: {
            idUser: history.oldClientCode
          },
        },
        "target": "_Blank"
      }
    }, [_vm._v(_vm._s(history.oldClientCode))])], 1)])])]), _vm._v(" "), _c('span', [_c('div', {
      staticClass: "details-content-info"
    }, [_c('div', {
      staticClass: "cursorPointer details-info-viajero mx-2"
    }, [_c('span', {}, [_vm._v("newClientCode:")]), _vm._v(" "), _c('span', {}, [_c('router-link', {
      attrs: {
        "to": {
          name: 'UserDetail',
          params: {
            idUser: history.newClientCode
          },
        },
        "target": "_Blank"
      }
    }, [_vm._v(_vm._s(history.newClientCode))])], 1)])])]), _vm._v(" "), _c('span', [_c('div', {
      staticClass: "details-content-info"
    }, [_c('div', {
      staticClass: "cursorNot details-info-viajero mx-2"
    }, [_c('span', {}, [_vm._v("status:")]), _vm._v(" "), _c('span', {}, [_vm._v(_vm._s(history.status))])])])])])])
  }), 0) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_vm._m(36), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "asociarWarehouse",
      "aria-labelledby": "Warehouse"
    }
  }, [_c('header', {
    staticClass: "switch"
  }, [_c('a', {
    staticClass: "switch__link",
    class: _vm.switchWR === 1 && 'switch__link--active',
    on: {
      "click": function($event) {
        return _vm.changeSiwtch(1)
      }
    }
  }, [_vm._v("\n                  Buscar WR\n                ")]), _vm._v(" "), _c('a', {
    staticClass: "switch__link",
    class: _vm.switchWR === 2 && 'switch__link--active',
    on: {
      "click": function($event) {
        return _vm.changeSiwtch(2)
      }
    }
  }, [_vm._v("\n                  Crear WR\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "switch__bg--active",
    class: _vm.switchWR === 1 ? 'switch__bg--left' : 'switch__bg--right'
  })]), _vm._v(" "), (_vm.switchWR === 1) ? _c('div', {
    staticClass: "details-content-info"
  }, [_c('label', {
    staticStyle: {
      "font-weight": "bold"
    },
    attrs: {
      "for": ""
    }
  }, [_vm._v("Buscar WR")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_c('form', {
    staticClass: "w-100",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.searchWrehouse()
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchWR),
      expression: "searchWR"
    }],
    staticClass: "form-control mb-3",
    attrs: {
      "type": "text",
      "placeholder": "Ingrese código",
      "required": ""
    },
    domProps: {
      "value": (_vm.searchWR)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchWR = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary d-block w-100",
    attrs: {
      "disabled": _vm.orderDataShow.attributes.status === 10,
      "type": "submit"
    }
  }, [_vm._v("\n                      Buscar\n                    ")])])])]) : _vm._e(), _vm._v(" "), (_vm.resultSearchWr) ? _c('div', {
    staticClass: "d-block mt-3",
    attrs: {
      "id": "accordion"
    }
  }, [_c('div', {
    staticClass: "d-flex justify-content-between w-100",
    staticStyle: {
      "float": "none"
    },
    attrs: {
      "id": "search",
      "data-toggle": "collapse",
      "data-target": "#clientsearch5",
      "aria-expanded": "false",
      "aria-controls": "clientsearch5"
    }
  }, [_c('span', [_vm._v("\n                    " + _vm._s(_vm.resultSearchWr.attributes.code) + " -\n                    "), _c('a', {
    staticStyle: {
      "color": "blue"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updatePaquete(_vm.resultSearchWr.id)
      }
    }
  }, [_vm._v("asignar")])]), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "clientsearch5",
      "aria-labelledby": "search"
    }
  }, [_c('div', {
    staticClass: "details-content-info"
  }, [_c('ul', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('li', [_vm._v("\n                        " + _vm._s(_vm.resultSearchWr.attributes.purchase_order_id ?
    _vm.resultSearchWr.attributes.purchase_order_id :
    "Sin orden asignada") + "\n                      ")]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.resultSearchWr.attributes.consignee))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.resultSearchWr.attributes.remitter))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.resultSearchWr.attributes.carrier))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.resultSearchWr.attributes.tracking))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.resultSearchWr.attributes.comment))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.resultSearchWr.attributes.weight))]), _vm._v(" "), _c('li', [_vm._v("\n                        " + _vm._s(_vm.resultSearchWr.attributes.weight_unit.attributes.key_name) + "\n                      ")]), _vm._v(" "), _vm._l((_vm.resultSearchWr.attributes.images), function(image, index) {
    return _c('li', {
      key: image
    }, [_c('a', {
      attrs: {
        "href": image.url,
        "target": "_Blank"
      }
    }, [_vm._v("Imagen - " + _vm._s(index + 1))])])
  })], 2)])])]) : _vm._e(), _vm._v(" "), (_vm.switchWR === 2) ? _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createPaquete.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "details-content-info"
  }, [_c('label', {
    staticStyle: {
      "font-weight": "bold"
    },
    attrs: {
      "for": ""
    }
  }, [_vm._v("Crear WR")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Remitente:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCreate.remitter),
      expression: "formCreate.remitter"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.formCreate.remitter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formCreate, "remitter", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Destinatario (Consignatario):")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCreate.consignee),
      expression: "formCreate.consignee"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.formCreate.consignee)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formCreate, "consignee", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Carrier:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCreate.carrier),
      expression: "formCreate.carrier"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.formCreate.carrier)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formCreate, "carrier", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Tracking:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCreate.tracking),
      expression: "formCreate.tracking"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.formCreate.tracking)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formCreate, "tracking", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Peso:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCreate.weight),
      expression: "formCreate.weight"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "type": "number",
      "name": "numero",
      "step": "0.1"
    },
    domProps: {
      "value": (_vm.formCreate.weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formCreate, "weight", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Unidad de peso:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCreate.unidad),
      expression: "formCreate.unidad"
    }],
    staticClass: "form-control",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.formCreate, "unidad", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "selected"
    },
    domProps: {
      "value": 12
    }
  }, [_vm._v("Kg")]), _vm._v(" "), _c('option', {
    attrs: {
      "selected": "selected"
    },
    domProps: {
      "value": 2
    }
  }, [_vm._v("Lb")]), _vm._v(" "), _c('option', {
    attrs: {
      "selected": "selected"
    },
    domProps: {
      "value": 22
    }
  }, [_vm._v("Oz")])])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Comentario:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formCreate.comment),
      expression: "formCreate.comment"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "name": "",
      "rows": "6",
      "required": ""
    },
    domProps: {
      "value": (_vm.formCreate.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formCreate, "comment", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Fotos del paquete:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "multiple": "",
      "disabled": _vm.orderDataShow.attributes.status === 10,
      "required": ""
    },
    on: {
      "change": _vm.handleFileInput
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('button', {
    staticClass: "btn btn-primary d-block w-100 mb-3",
    attrs: {
      "disabled": _vm.orderDataShow.attributes.status === 10 ||
        _vm.orderDataShow.attributes.warehouse_flag == 1,
      "type": "submit"
    }
  }, [_vm._v("\n                    Guardar\n                  ")])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_vm._m(37), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "clientWarehouse",
      "aria-labelledby": "Warehouse"
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createPaquete.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "details-content-info"
  }, [_c('button', {
    staticClass: "btn d-block w-100",
    class: _vm.orderDataShow.attributes.warehouse_flag == 0 ?
      'btn-primary' :
      'btn-success',
    attrs: {
      "disabled": _vm.orderDataShow.attributes.status === 10 ||
        _vm.listWarehouse.length === 0
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.limitchangePaquete()
      }
    }
  }, [(_vm.orderDataShow.attributes.warehouse_flag !== 0) ? _c('i', {
    staticClass: "fas fa-check pr-2 pt-1"
  }) : _vm._e(), _vm._v("\n                    " + _vm._s(_vm.orderDataShow.attributes.warehouse_flag == 0 ?
    "Items incompletos" :
    "Items completos") + "\n                  ")])])]), _vm._v(" "), _vm._l((_vm.listWarehouse), function(data) {
    return _c('div', {
      key: data,
      staticStyle: {
        "margin-top": "25px"
      },
      attrs: {
        "id": "accordion"
      }
    }, [_c('div', {
      staticClass: "details-content-title collapsed",
      attrs: {
        "id": 'warehouse' + data.id,
        "data-toggle": "collapse",
        "data-target": '#clientwarehouse' + data.id,
        "aria-expanded": "false",
        "aria-controls": 'clientwarehouse' + data.id
      }
    }, [_c('span', [_vm._v("\n                    " + _vm._s(data.attributes.code) + "\n                    "), _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "color": "blue"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.liberarWR(data.attributes.code)
        }
      }
    }, [_vm._v("\n                      Liberar\n                    ")])]), _vm._v(" "), _c('div', {
      staticClass: "details-text up-arrow"
    })]), _vm._v(" "), _c('div', {
      staticClass: "collapse",
      attrs: {
        "id": 'clientwarehouse' + data.id,
        "aria-labelledby": 'warehouse' + data.id
      }
    }, [_c('ul', [_c('li', [_vm._v(_vm._s(data.attributes.purchase_order_id))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(data.attributes.consignee))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(data.attributes.remitter))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(data.attributes.carrier))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(data.attributes.tracking))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(data.attributes.comment))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(data.attributes.weight))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(data.attributes.weight_unit.attributes.key_name))]), _vm._v(" "), _vm._l((data.attributes.images), function(image, index) {
      return _c('li', {
        key: image
      }, [_c('a', {
        attrs: {
          "href": image.url,
          "target": "_Blank"
        }
      }, [_vm._v("Imagen - " + _vm._s(index + 1))])])
    })], 2)])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_vm._m(38), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "clientInformationEntregaDeSendi",
      "aria-labelledby": "informationEntregaDeSendi"
    }
  }, [_c('div', {
    staticClass: "details-content-info"
  }, [_c('span', [_c('form', {
    attrs: {
      "action": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveEntregaSendi.apply(null, arguments)
      }
    }
  }, [_vm._m(39), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entregaSendi.entrega),
      expression: "entregaSendi.entrega"
    }],
    staticClass: "form-control",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entregaSendi, "entrega", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "Oficina"
    }
  }, [_vm._v("Oficina")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Dirección"
    }
  }, [_vm._v("Dirección")])])])]), _vm._v(" "), _vm._m(40), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entregaSendi.desciption),
      expression: "entregaSendi.desciption"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "",
      "id": "",
      "cols": "30",
      "rows": "10"
    },
    domProps: {
      "value": (_vm.entregaSendi.desciption)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entregaSendi, "desciption", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _vm._m(41), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "disabled": _vm.orderDataShow.attributes.status === 10,
      "required": ""
    },
    on: {
      "change": _vm.evidenciaSendi
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_c('button', {
    staticClass: "btn btn-primary form-control",
    attrs: {
      "disabled": _vm.orderDataShow.attributes.status === 10,
      "type": "submit"
    }
  }, [_vm._v("\n                          Guardar\n                        ")])])])]), _vm._v(" "), _vm._l((_vm.entregaSendiList), function(data, index) {
    return _c('div', {
      key: data,
      staticStyle: {
        "margin-top": "25px"
      },
      attrs: {
        "id": "accordion"
      }
    }, [_c('div', {
      staticClass: "details-content-title collapsed",
      attrs: {
        "id": 'entregaSendi' + data.id,
        "data-toggle": "collapse",
        "data-target": '#cliententregaSendi' + data.id,
        "aria-expanded": "false",
        "aria-controls": 'cliententregaSendi' + data.id
      }
    }, [_c('span', [_c('center', [_vm._v("\n                          Evidencias - " + _vm._s(index + 1) + " -\n                          "), _c('span', {
      staticStyle: {
        "color": "red",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.deleteEntregaSendi(data.id)
        }
      }
    }, [_vm._v("Eliminar")])])], 1), _vm._v(" "), _c('div', {
      staticClass: "details-text up-arrow"
    })]), _vm._v(" "), _c('div', {
      staticClass: "collapse",
      attrs: {
        "id": 'cliententregaSendi' + data.id,
        "aria-labelledby": 'entregaSendi' + data.id
      }
    }, [_c('ul', [_c('li', [_vm._v(_vm._s(data.delivery))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(data.description))]), _vm._v(" "), _c('li', [_c('a', {
      attrs: {
        "href": data.evidence,
        "target": "_Blank"
      }
    }, [_vm._v("Ver imagen")])])])])])
  })], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_vm._m(42), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "clientInformationD31223",
      "aria-labelledby": "informationD31223"
    }
  }, [_c('form', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_vm._m(43), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localInternacionalTracking.codigo),
      expression: "localInternacionalTracking.codigo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": "",
      "minlength": "5"
    },
    domProps: {
      "value": (_vm.localInternacionalTracking.codigo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.localInternacionalTracking, "codigo", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _vm._m(44), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localInternacionalTracking.type),
      expression: "localInternacionalTracking.type"
    }],
    staticClass: "form-control",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.localInternacionalTracking, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.orderDataShow.attributes.origin.attributes.name) + " -\n                        " + _vm._s(_vm.orderDataShow.attributes.destination.attributes.name) + "\n                      ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.orderDataShow.attributes.destination.attributes.name) + " -\n                        " + _vm._s(_vm.orderDataShow.attributes.origin.attributes.name) + "\n                      ")])])])]), _vm._v(" "), _vm._m(45), _vm._v(" "), _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectTracking),
      expression: "selectTracking"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectTracking = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "L"
    }
  }, [_vm._v("Nacional Tracking")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "I"
    }
  }, [_vm._v("International Tracking")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.orderDataShow.attributes.status === 10,
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.selectTracking === 'L' ?
          _vm.createdLocalTracking() :
          _vm.createdInternationalTracking()
      }
    }
  }, [_vm._v("\n                        Guardar\n                      ")])])])])]), _vm._v(" "), (_vm.dataLocalTracking.length !== 0) ? _c('span', [_vm._v("NACIONAL")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.dataLocalTracking), function(data, index) {
    return _c('div', {
      key: data,
      staticStyle: {
        "margin-bottom": "25px",
        "margin-top": "12px"
      },
      attrs: {
        "id": "accordion"
      }
    }, [_c('div', {
      staticClass: "details-content-title collapsed",
      attrs: {
        "id": 'informationLocal' + index,
        "data-toggle": "collapse",
        "data-target": '#clientInformationLocal' + index,
        "aria-expanded": "false",
        "aria-controls": 'clientInformationLocal' + index
      }
    }, [_c('span', [_c('img', {
      attrs: {
        "src": "/static/img/olva.png",
        "width": "20",
        "alt": ""
      }
    }), _vm._v("\n                    " + _vm._s(data.data.general.remito) + "-\n                    " + _vm._s(data.data.type === 1 ? "Ida" : "Vuelta") + " -\n                    " + _vm._s(data.data.details[0].estado_tracking)), _c('br'), _vm._v(" "), (_vm.orderDataShow.attributes.status !== 10) ? _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "color": "red"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.deleteTrackingLocal(data.data.general.remito)
        }
      }
    }, [_vm._v("Eliminar")]) : _vm._e(), _vm._v("-"), (_vm.orderDataShow.attributes.status !== 10) ? _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "color": "#5974bb"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.changeHiddenLocal(data.data.general.remito, data.data.hide)
        }
      }
    }, [_vm._v("\n                      " + _vm._s(data.data.hide === 1 || data.data.hide === true ?
      "Ocultar" :
      "Mostrar"))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "details-text up-arrow"
    })]), _vm._v(" "), _c('div', {
      staticClass: "collapse",
      attrs: {
        "id": 'clientInformationLocal' + index,
        "aria-labelledby": 'informationLocal' + index
      }
    }, [_vm._l((data.data.details), function(items) {
      return _c('div', {
        key: items
      }, [(items.estado_tracking == 'ENTREGADO') ? _c('img', {
        staticStyle: {
          "width": "10%"
        },
        attrs: {
          "src": "https://www.tracktry.com/section/tracktry/images/Artboard-6.svg"
        }
      }) : (items.estado_tracking == 'REGISTRADO') ? _c('img', {
        staticStyle: {
          "width": "10%"
        },
        attrs: {
          "src": "https://www.tracktry.com/section/tracktry/images/Artboard-5.svg"
        }
      }) : _c('img', {
        staticStyle: {
          "width": "10%"
        },
        attrs: {
          "src": "https://www.tracktry.com/section/tracktry/images/Artboard-1.svg"
        }
      }), _vm._v("\n                    " + _vm._s(items.fecha_creacion) + "\n                    "), _c('p', [_c('strong', [_vm._v(_vm._s(items.estado_tracking))]), _vm._v(", " + _vm._s(items.obs) + "\n                    ")])])
    }), _vm._v(" "), _vm._l((data.data.imagenes), function(images, index) {
      return _c('div', {
        key: images
      }, [_c('a', {
        attrs: {
          "href": images.url,
          "target": "_Blank"
        }
      }, [_vm._v("Imagen - " + _vm._s(index + 1))])])
    })], 2)])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_vm._m(46), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "clientInformationD512",
      "aria-labelledby": "informationD512"
    }
  }, [(_vm.orderDataShow.attributes.status !== 10) ? _c('div', {
    staticClass: "details-content-info"
  }, _vm._l((_vm.orderDataShow.attributes
    .order_tracking_details), function(histTracking) {
    return _c('span', {
      key: histTracking,
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.deleteTackingStatus(histTracking.id, histTracking.attributes.status)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(histTracking.attributes.status) + " -\n                  "), _vm._l((_vm.statusTracking), function(tracking) {
      return _c('span', {
        key: tracking
      }, [(tracking.id === histTracking.attributes.status) ? _c('span', [_vm._v("\n                      " + _vm._s(tracking.text) + "\n                      "), _c('ul', [_c('li', [_vm._v(_vm._s(histTracking.attributes.date_time))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(histTracking.attributes.admin_name))])])]) : _vm._e()])
    }), _c('br')], 2)
  }), 0) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_vm._m(47), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "clientInformationD5",
      "aria-labelledby": "informationD5"
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.buscarViajero.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "details-content-info"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataInputViajero),
      expression: "dataInputViajero"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Ingresar los datos del viajero a buscar",
      "required": ""
    },
    domProps: {
      "value": (_vm.dataInputViajero)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dataInputViajero = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.buscarViajeroCampo),
      expression: "buscarViajeroCampo"
    }],
    staticClass: "form-control",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.buscarViajeroCampo = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Buscar por nombre del viajero")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Buscar por còdigo del viajero")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('button', {
    staticClass: "btn btn-primary form-control",
    attrs: {
      "disabled": _vm.orderDataShow.attributes.status === 10,
      "type": "submit"
    }
  }, [_vm._v("\n                    Buscar Viajero\n                  ")])])]), _vm._v(" "), (_vm.orderDataShow.attributes.client_travel !== null) ? _c('div', {
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "id": "accordion"
    }
  }, [_c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": 'information' +
        _vm.orderDataShow.attributes.client_travel.attributes.client_id,
      "data-toggle": "collapse",
      "data-target": '#clientInformation' +
        _vm.orderDataShow.attributes.client_travel.attributes.client_id,
      "aria-expanded": "false",
      "aria-controls": 'clientInformation' +
        _vm.orderDataShow.attributes.client_travel.attributes.client_id
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.orderDataShow.attributes.client_travel.attributes.client
    .attributes.profile.attributes.name +
    _vm.orderDataShow.attributes.client_travel.attributes.client
    .attributes.profile.attributes.surnames +
    " - " +
    _vm.orderDataShow.attributes.client_travel.attributes.client
    .attributes.profile.attributes.userable.client_code) + "\n                    "), _c('br'), _vm._v("\n                    \"Viajero Elejido\"\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": 'clientInformation' +
        _vm.orderDataShow.attributes.client_travel.attributes.client_id,
      "aria-labelledby": 'information' +
        _vm.orderDataShow.attributes.client_travel.attributes.client_id
    }
  }, [_c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Código:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v(_vm._s(_vm.orderDataShow.attributes.client_travel.attributes.client
    .attributes.profile.id))])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Nombre:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                        " + _vm._s(_vm.orderDataShow.attributes.client_travel.attributes.client
    .attributes.profile.attributes.name) + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Apellido:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                        " + _vm._s(_vm.orderDataShow.attributes.client_travel.attributes.client
    .attributes.profile.attributes.surnames) + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Documento:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                        " + _vm._s(_vm.orderDataShow.attributes.client_travel.attributes.client
    .attributes.profile.attributes.document_number) + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Teléfono:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                        " + _vm._s(_vm.orderDataShow.attributes.client_travel.attributes.client
    .attributes.profile.attributes.cellphone) + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Dirección:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                        " + _vm._s(_vm.orderDataShow.attributes.client_travel.attributes.client
    .attributes.profile.attributes.userable.attributes
    .address !== null ?
    _vm.orderDataShow.attributes.client_travel.attributes.client
    .attributes.profile.attributes.userable.attributes
    .address.address :
    "") + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Piso u Oficina:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                        " + _vm._s(_vm.orderDataShow.attributes.client_travel.attributes.client
    .attributes.profile.attributes.userable.attributes
    .address !== null ?
    _vm.orderDataShow.attributes.client_travel.attributes.client
    .attributes.profile.attributes.userable.attributes
    .address.inner :
    "") + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Referencia:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                        " + _vm._s(_vm.orderDataShow.attributes.client_travel.attributes.client
    .attributes.profile.attributes.userable.attributes
    .address !== null ?
    _vm.orderDataShow.attributes.client_travel.attributes.client
    .attributes.profile.attributes.userable.attributes
    .address.reference :
    "") + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Departamento:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                        " + _vm._s(_vm.orderDataShow.attributes.client_travel.attributes.client
    .attributes.profile.attributes.userable.attributes
    .address !== null ?
    _vm.orderDataShow.attributes.client_travel.attributes.client
    .attributes.profile.attributes.userable.attributes
    .address.department :
    "") + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Provincia:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                        " + _vm._s(_vm.orderDataShow.attributes.client_travel.attributes.client
    .attributes.profile.attributes.userable.attributes
    .address !== null ?
    _vm.orderDataShow.attributes.client_travel.attributes.client
    .attributes.profile.attributes.userable.attributes
    .address.city :
    "") + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Distrito:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                        " + _vm._s(_vm.orderDataShow.attributes.client_travel.attributes.client
    .attributes.profile.attributes.userable.attributes
    .address !== null ?
    _vm.orderDataShow.attributes.client_travel.attributes.client
    .attributes.profile.attributes.userable.attributes
    .address.istrict :
    "") + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Corro electrónico:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                        " + _vm._s(_vm.orderDataShow.attributes.client_travel.attributes.client
    .attributes.profile.attributes.userable.attributes.email) + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Status:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                        " + _vm._s(_vm.orderDataShow.attributes.client_travel.attributes.client
    .attributes.profile.attributes.userable.attributes
    .validation.miss === "none" ?
    "Verificado" :
    "No Verificado") + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Credencial Frontal:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                        " + _vm._s(_vm.orderDataShow.attributes.client_travel.attributes.client
    .attributes.profile.attributes.userable.attributes
    .validation.miss === "none" ||
    _vm.orderDataShow.attributes.client_travel.attributes.client
    .attributes.profile.attributes.userable.attributes
    .validation.miss === "seal" ?
    "Verificado" :
    "No Verificado") + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Credencial trasera:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                        " + _vm._s(_vm.orderDataShow.attributes.client_travel.attributes.client
    .attributes.profile.attributes.userable.attributes
    .validation.miss === "none" ||
    _vm.orderDataShow.attributes.client_travel.attributes.client
    .attributes.profile.attributes.userable.attributes
    .validation.miss === "face" ?
    "Verificado" :
    "No Verificado") + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Código de usuario:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                        " + _vm._s(_vm.orderDataShow.attributes.client_travel.attributes.client
    .attributes.profile.attributes.userable.client_code) + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Origen :")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                        " + _vm._s(_vm.orderDataShow.attributes.client_travel.attributes.origin) + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Destino:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                        " + _vm._s(_vm.orderDataShow.attributes.client_travel.attributes.destination) + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Fecha de llegada:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("\n                        " + _vm._s(_vm.orderDataShow.attributes.client_travel.attributes.arrival_date) + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.orderDataShow.attributes.status === 10,
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.quitarViajero()
      }
    }
  }, [_vm._v("\n                      Quitar de la orden\n                    ")])])])]) : _vm._e(), _vm._v(" "), (_vm.dataViajeros.length !== 0) ? _c('span', _vm._l((_vm.dataViajeros), function(viajes) {
    return _c('div', {
      key: viajes.id,
      staticClass: "mt-4",
      attrs: {
        "id": "accordion"
      }
    }, [_c('div', {
      staticClass: "details-content-title collapsed pb-2 mb-3",
      staticStyle: {
        "border-bottom": "1px solid #ccc"
      },
      attrs: {
        "id": 'information' + viajes.id,
        "data-toggle": "collapse",
        "data-target": '#clientInformation' + viajes.id,
        "aria-expanded": "false",
        "aria-controls": 'clientInformation' + viajes.id
      }
    }, [_c('article', {
      staticClass: "p-0"
    }, [_c('p', {
      staticClass: "m-0 mb-2",
      staticStyle: {
        "font-size": "14px"
      }
    }, [_vm._v("\n                        " + _vm._s(viajes.attributes.client.attributes.profile.attributes.name) + "\n                      ")]), _vm._v(" "), _c('p', {
      staticClass: "m-0 mb-2",
      staticStyle: {
        "font-size": "14px"
      }
    }, [_vm._v("\n                        " + _vm._s(viajes.attributes.client.attributes.profile.attributes
      .surnames) + "\n                      ")]), _vm._v(" "), _c('p', {
      staticClass: "m-0 mb-2",
      staticStyle: {
        "font-size": "14px"
      }
    }, [_vm._v("\n                        " + _vm._s(viajes.attributes.client.client_code) + "\n                      ")]), _vm._v(" "), _c('p', {
      staticClass: "m-0 mb-2",
      staticStyle: {
        "font-size": "14px"
      }
    }, [_vm._v("\n                        Viaje Origen : " + _vm._s(viajes.attributes.origin) + "\n                      ")]), _vm._v(" "), _c('p', {
      staticClass: "m-0 mb-2",
      staticStyle: {
        "font-size": "14px"
      }
    }, [_vm._v("\n                        Viaje Destino : " + _vm._s(viajes.attributes.destination) + "\n                      ")]), _vm._v(" "), _c('p', {
      staticClass: "m-0",
      staticStyle: {
        "font-size": "14px"
      }
    }, [_vm._v("\n                        Fecha Llegada : " + _vm._s(viajes.attributes.arrival_date) + "\n                      ")])]), _vm._v(" "), _c('div', {
      staticClass: "details-text up-arrow"
    })]), _vm._v(" "), _c('div', {
      staticClass: "collapse",
      attrs: {
        "id": 'clientInformation' + viajes.id,
        "aria-labelledby": 'information' + viajes.id
      }
    }, [_c('span', [_c('div', {
      staticClass: "details-content-info"
    }, [_c('div', {
      staticClass: "details-info-viajero mx-2"
    }, [_c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("Código:")]), _vm._v(" "), _c('span', {
      staticClass: "details-title-item"
    }, [_vm._v(_vm._s(viajes.attributes.client.id))])])]), _vm._v(" "), _c('div', {
      staticClass: "details-content-info"
    }, [_c('div', {
      staticClass: "details-info-viajero mx-2"
    }, [_c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("Nombre:")]), _vm._v(" "), _c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("\n                            " + _vm._s(viajes.attributes.client.attributes.profile.attributes
      .name) + "\n                          ")])])]), _vm._v(" "), _c('div', {
      staticClass: "details-content-info"
    }, [_c('div', {
      staticClass: "details-info-viajero mx-2"
    }, [_c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("Apellido:")]), _vm._v(" "), _c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("\n                            " + _vm._s(viajes.attributes.client.attributes.profile.attributes
      .surnames) + "\n                          ")])])]), _vm._v(" "), _c('div', {
      staticClass: "details-content-info"
    }, [_c('div', {
      staticClass: "details-info-viajero mx-2"
    }, [_c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("Documento:")]), _vm._v(" "), _c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("\n                            " + _vm._s(viajes.attributes.client.attributes.profile.attributes
      .document_number) + "\n                          ")])])]), _vm._v(" "), _c('div', {
      staticClass: "details-content-info"
    }, [_c('div', {
      staticClass: "details-info-viajero mx-2"
    }, [_c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("Teléfono:")]), _vm._v(" "), _c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("\n                            " + _vm._s(viajes.attributes.client.attributes.profile.attributes
      .cellphone) + "\n                          ")])])]), _vm._v(" "), _c('div', {
      staticClass: "details-content-info"
    }, [_c('div', {
      staticClass: "details-info-viajero mx-2"
    }, [_c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("Dirección:")]), _vm._v(" "), _c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("\n                            " + _vm._s(viajes.attributes.client.attributes.address !== null ?
      viajes.attributes.client.attributes.address.address :
      "") + "\n                          ")])])]), _vm._v(" "), _c('div', {
      staticClass: "details-content-info"
    }, [_c('div', {
      staticClass: "details-info-viajero mx-2"
    }, [_c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("Piso u Oficina:")]), _vm._v(" "), _c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("\n                            " + _vm._s(viajes.attributes.client.attributes.address !== null ?
      viajes.attributes.client.attributes.address.inner :
      "") + "\n                          ")])])]), _vm._v(" "), _c('div', {
      staticClass: "details-content-info"
    }, [_c('div', {
      staticClass: "details-info-viajero mx-2"
    }, [_c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("Referencia:")]), _vm._v(" "), _c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("\n                            " + _vm._s(viajes.attributes.client.attributes.address !== null ?
      viajes.attributes.client.attributes.address.reference :
      "") + "\n                          ")])])]), _vm._v(" "), _c('div', {
      staticClass: "details-content-info"
    }, [_c('div', {
      staticClass: "details-info-viajero mx-2"
    }, [_c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("Departamento:")]), _vm._v(" "), _c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("\n                            " + _vm._s(viajes.attributes.client.attributes.address !== null ?
      viajes.attributes.client.attributes.address.department :
      "") + "\n                          ")])])]), _vm._v(" "), _c('div', {
      staticClass: "details-content-info"
    }, [_c('div', {
      staticClass: "details-info-viajero mx-2"
    }, [_c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("Provincia:")]), _vm._v(" "), _c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("\n                            " + _vm._s(viajes.attributes.client.attributes.address !== null ?
      viajes.attributes.client.attributes.address.city :
      "") + "\n                          ")])])]), _vm._v(" "), _c('div', {
      staticClass: "details-content-info"
    }, [_c('div', {
      staticClass: "details-info-viajero mx-2"
    }, [_c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("Distrito:")]), _vm._v(" "), _c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("\n                            " + _vm._s(viajes.attributes.client.attributes.address !== null ?
      viajes.attributes.client.attributes.address.district :
      "") + "\n                          ")])])]), _vm._v(" "), _c('div', {
      staticClass: "details-content-info"
    }, [_c('div', {
      staticClass: "details-info-viajero mx-2"
    }, [_c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("Corro electrónico:")]), _vm._v(" "), _c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("\n                            " + _vm._s(viajes.attributes.client.attributes.email) + "\n                          ")])])]), _vm._v(" "), _c('div', {
      staticClass: "details-content-info"
    }, [_c('div', {
      staticClass: "details-info-viajero mx-2"
    }, [_c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("Status:")]), _vm._v(" "), _c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("\n                            " + _vm._s(viajes.attributes.client.attributes.validation.miss ===
      "none" ?
      "Verificado" :
      "No Verificado") + "\n                          ")])])]), _vm._v(" "), _c('div', {
      staticClass: "details-content-info"
    }, [_c('div', {
      staticClass: "details-info-viajero mx-2"
    }, [_c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("Credencial Frontal:")]), _vm._v(" "), _c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("\n                            " + _vm._s(viajes.attributes.client.attributes.validation.miss ===
      "none" ||
      viajes.attributes.client.attributes.validation.miss ===
      "seal" ?
      "Verificado" :
      "No Verificado") + "\n                          ")])])]), _vm._v(" "), _c('div', {
      staticClass: "details-content-info"
    }, [_c('div', {
      staticClass: "details-info-viajero mx-2"
    }, [_c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("Credencial trasera:")]), _vm._v(" "), _c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("\n                            " + _vm._s(viajes.attributes.client.attributes.validation.miss ===
      "none" ||
      viajes.attributes.client.attributes.validation.miss ===
      "face" ?
      "Verificado" :
      "No Verificado") + "\n                          ")])])]), _vm._v(" "), _c('div', {
      staticClass: "details-content-info"
    }, [_c('div', {
      staticClass: "details-info-viajero mx-2"
    }, [_c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("Código de usuario:")]), _vm._v(" "), _c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("\n                            " + _vm._s(viajes.attributes.client.attributes.profile.attributes
      .userable.client_code) + "\n                          ")])])]), _vm._v(" "), _c('div', {
      staticClass: "details-content-info"
    }, [_c('button', {
      staticClass: "btn btn-primary form-control",
      attrs: {
        "disabled": _vm.orderDataShow.attributes.status === 10
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.asignarViajeroOrder(
            viajes.id,
            viajes.attributes.client.attributes.profile.attributes
            .userable.client_code
          )
        }
      }
    }, [_vm._v("\n                          Asignar VIajero\n                        ")])])])])])
  }), 0) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content"
  }, [_c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_vm._m(48), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "clientInformationD3",
      "aria-labelledby": "informationD3"
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.addInternationalShooper.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Tienda de compra :")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.interShooper.tienda),
      expression: "interShooper.tienda"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.interShooper.tienda)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.interShooper, "tienda", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Enlace:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.interShooper.enlace),
      expression: "interShooper.enlace"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.interShooper.enlace)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.interShooper, "enlace", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Precio:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.interShooper.precio),
      expression: "interShooper.precio"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.interShooper.precio)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.interShooper, "precio", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Cantidad:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.interShooper.cantidad),
      expression: "interShooper.cantidad"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.interShooper.cantidad)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.interShooper, "cantidad", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Peso:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.interShooper.peso),
      expression: "interShooper.peso"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.interShooper.peso)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.interShooper, "peso", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Order number:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.interShooper.order),
      expression: "interShooper.order"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.interShooper.order)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.interShooper, "order", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Invoice Details:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_c('input', {
    ref: "invoice",
    attrs: {
      "disabled": _vm.orderDataShow.attributes.status === 10,
      "type": "file"
    },
    on: {
      "change": _vm.invoice
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_c('button', {
    staticClass: "btn btn-primary form-control",
    attrs: {
      "disabled": _vm.orderDataShow.attributes.status === 10,
      "type": "submit"
    }
  }, [_vm._v("\n                        Recopilar\n                      ")])])])])]), _vm._v(" "), _vm._l((_vm.dataInternationalShooper), function(data) {
    return _c('div', {
      key: data,
      staticStyle: {
        "margin-top": "20px"
      },
      attrs: {
        "id": "accordion"
      }
    }, [_c('div', {
      staticClass: "details-content-title collapsed",
      attrs: {
        "id": 'informationD3' + data.id,
        "data-toggle": "collapse",
        "data-target": '#clientInformationD3' + data.id,
        "aria-expanded": "false",
        "aria-controls": 'clientInformationD3' + data.id
      }
    }, [_c('span', [_vm._v("International Shopper - " + _vm._s(data.tiendaCompra) + " "), _c('br'), _vm._v(" "), (_vm.orderDataShow.attributes.status !== 10) ? _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "color": "red"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.deleteInternationalShooper(data.id)
        }
      }
    }, [_vm._v("Eliminar")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "details-text up-arrow"
    })]), _vm._v(" "), _c('div', {
      staticClass: "collapse",
      attrs: {
        "id": 'clientInformationD3' + data.id,
        "aria-labelledby": 'informationD3' + data.id
      }
    }, [_c('div', {
      staticClass: "details-content-info"
    }, [_c('div', {
      staticClass: "details-title-block"
    }, [_c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("Tienda de compra :")]), _vm._v(" "), _c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("\n                        " + _vm._s(data.tiendaCompra) + "\n                      ")])])]), _vm._v(" "), _c('div', {
      staticClass: "details-content-info"
    }, [_c('div', {
      staticClass: "details-title-block"
    }, [_c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("Enlace:")]), _vm._v(" "), _c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("\n                        " + _vm._s(data.enlace) + "\n                      ")])])]), _vm._v(" "), _c('div', {
      staticClass: "details-content-info"
    }, [_c('div', {
      staticClass: "details-title-block"
    }, [_c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("Precio:")]), _vm._v(" "), _c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("\n                        " + _vm._s(data.precio) + "\n                      ")])])]), _vm._v(" "), _c('div', {
      staticClass: "details-content-info"
    }, [_c('div', {
      staticClass: "details-title-block"
    }, [_c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("Cantidad:")]), _vm._v(" "), _c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("\n                        " + _vm._s(data.cantidad) + "\n                      ")])])]), _vm._v(" "), _c('div', {
      staticClass: "details-content-info"
    }, [_c('div', {
      staticClass: "details-title-block"
    }, [_c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("Peso:")]), _vm._v(" "), _c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("\n                        " + _vm._s(data.peso) + "\n                      ")])])]), _vm._v(" "), _c('div', {
      staticClass: "details-content-info"
    }, [_c('div', {
      staticClass: "details-title-block"
    }, [_c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("Order number:")]), _vm._v(" "), _c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("\n                        " + _vm._s(data.orderNumber) + "\n                      ")])])]), _vm._v(" "), _c('div', {
      staticClass: "details-content-info"
    }, [_c('div', {
      staticClass: "details-title-block"
    }, [_c('span', {
      staticClass: "details-title-item"
    }, [_vm._v("Invoice Details:")]), _vm._v(" "), _c('span', {
      staticClass: "details-title-item"
    }, [(data.invoiceDetails === null) ? _c('span', [_vm._v(" Sin Invoice ")]) : _c('span', [_c('a', {
      attrs: {
        "href": data.invoiceDetails,
        "target": "Blank"
      }
    }, [_vm._v("Ver Invoice")])])])])])])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "details-title-container"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "disabled": _vm.orderDataShow.attributes.status === 10,
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showModalConfirmationDelete()
      }
    }
  }, [_vm._v("\n            Eliminar orden\n          ")])])], 2)]), _vm._v(" "), _c('b-modal', {
    ref: "modalAuthorizeReposition",
    attrs: {
      "hide-footer": "",
      "hide-header": "",
      "centered": "",
      "id": "modalAuthorizeReposition"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("\n            Autorización de reposición del paquete\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close",
      "block": ""
    },
    on: {
      "click": _vm.hideModalAuthorizeReposition
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "id": "modal-body"
    }
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("\n            ¿Desea autorizar la reposición de ejemplares de un paquete a otro en la\n            presente orden de compra?\n          ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.authorizationOption),
      expression: "authorizationOption"
    }],
    attrs: {
      "type": "radio",
      "id": "one",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.authorizationOption, "1")
    },
    on: {
      "change": function($event) {
        _vm.authorizationOption = "1"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "one"
    }
  }, [_vm._v("Sí")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.authorizationOption),
      expression: "authorizationOption"
    }],
    attrs: {
      "type": "radio",
      "id": "two",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.authorizationOption, "2")
    },
    on: {
      "change": function($event) {
        _vm.authorizationOption = "2"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "two"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('span', [_vm._v("Opción elegida: " + _vm._s(_vm.authorizationOption))]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.authorizeReposition
    }
  }, [_vm._v("Enviar decisión")])])])]), _vm._v(" "), (
    _vm.orderDataShow.attributes.reposition.attributes.used_items != null &&
    _vm.orderDataShow.attributes.reposition.attributes.used_items > 0
  ) ? _c('b-modal', {
    ref: "modalRepositionDetail",
    attrs: {
      "hide-footer": "",
      "hide-header": "",
      "id": "modalRepositionDetail"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Detalle de reposición")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body modal-scroll",
    attrs: {
      "id": "modal-body"
    }
  }, [_c('span', [_c('b', [_vm._v("Items totales en la reposición:\n              " + _vm._s(_vm.orderDataShow.attributes.reposition.attributes.used_items))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Items pendientes de reposición:\n            " + _vm._s(_vm.orderDataShow.attributes.reposition.attributes.pendient_items))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Items repuestos:\n            " + _vm._s(_vm.orderDataShow.attributes.reposition.attributes.used_items -
    _vm.orderDataShow.attributes.reposition.attributes.pendient_items))]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.orderDataShow.attributes.reposition.attributes.child_id != null) ? _c('p', [_vm._v("\n            Ver reposición de items nuevamente incidentados en reposición de ID:\n            " + _vm._s(_vm.orderDataShow.attributes.reposition.attributes.child_id) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('span', [_vm._v("Incidencias por cantidades menores a lo solicitado:")]), _vm._v(" "), _c('ul', _vm._l((_vm.packageRepositions), function(packageRepo) {
    return _c('li', {
      key: packageRepo.id
    }, [_c('span', [_vm._v("ID Paquete")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(packageRepo.package_id))]), _vm._v(" "), _c('span', [_vm._v("ID Incidente")]), _vm._v(" "), _c('p', [_vm._v("\n                " + _vm._s(packageRepo.attributes.different_quantity_incident.attributes
      .packageIncident.id) + "\n              ")]), _vm._v(" "), _c('span', [_vm._v("Items que debieron ser correctos")]), _vm._v(" "), _c('p', [_vm._v("\n                " + _vm._s(packageRepo.attributes.quantity +
      packageRepo.attributes.different_quantity_incident.attributes
      .correct_items) + "\n              ")]), _vm._v(" "), _c('span', [_vm._v("Items realmente correctos")]), _vm._v(" "), _c('p', [_vm._v("\n                " + _vm._s(packageRepo.attributes.different_quantity_incident.attributes
      .correct_items) + "\n              ")]), _vm._v(" "), _c('span', [_vm._v("Items en déficit")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(packageRepo.attributes.quantity))]), _vm._v(" "), _c('span', [_vm._v("Enlace a embarque que perteneció el paquete:")]), _vm._v(" "), _c('p', [_vm._v("\n                Enlace a embarque de ID\n                " + _vm._s(packageRepo.attributes.different_quantity_incident.attributes
      .packageIncident.attributes.package.attributes.boarding_id) + "\n              ")])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), _c('b-modal', {
    ref: "modalConfirmationReposition",
    attrs: {
      "hide-footer": "",
      "hide-header": "",
      "centered": "",
      "id": "modalConfirmationReposition"
    }
  }, [_c('div', {
    staticClass: "modal-Content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Confirmar acción:")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.hideModalConfirmationReposition
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "id": "modal-body"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('p', [_vm._v("¿Estás seguro que deseas completar esta acción?")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.authorizeReposition()
      }
    }
  }, [_vm._v("\n            Aceptar\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.hideModalConfirmationReposition()
      }
    }
  }, [_vm._v("\n            Cancelar\n          ")])])])]), _vm._v(" "), _c('b-modal', {
    ref: "modalReevaluation",
    attrs: {
      "hide-footer": "",
      "hide-header": "",
      "centered": "",
      "id": "modalReevaluation"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("\n            Evaluación de la orden de compra\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.hideModalReevaluetion
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-tab"
  }, [_c('ul', {
    staticClass: "nav nav-pills nav-fill",
    attrs: {
      "id": "myTab",
      "role": "tablist"
    }
  }, [_c('li', {
    staticClass: "nav-item"
  }, [(_vm.flagFormEvaluetionPurchaseOrder != 'toFill') ? _c('a', {
    staticClass: "nav-link",
    class: {
      active: _vm.controllSwithPurchaseOrder == 1
    },
    on: {
      "click": function($event) {
        return _vm.modalControllPurchaseOrder(2)
      }
    }
  }, [_vm._v("Datos web")]) : _vm._e(), _vm._v(" "), (_vm.flagFormEvaluetionPurchaseOrder == 'toFill') ? _c('p', {
    staticClass: "nav-link active"
  }, [_vm._v("\n                Datos web\n              ")]) : _vm._e()]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [(_vm.flagFormEvaluetionPurchaseOrder != 'toFill') ? _c('a', {
    staticClass: "nav-link",
    class: {
      active: _vm.controllSwithPurchaseOrder == 2
    },
    on: {
      "click": function($event) {
        return _vm.modalControllPurchaseOrder(2)
      }
    }
  }, [_vm._v("Datos reales")]) : _vm._e(), _vm._v(" "), (_vm.flagFormEvaluetionPurchaseOrder == 'toFill') ? _c('p', {
    staticClass: "nav-link inactive"
  }, [_vm._v("\n                Datos reales\n              ")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body modal-scroll modal-tabs",
    attrs: {
      "id": "modal-body"
    }
  }, [_c('div', {
    staticClass: "form-login"
  }, [_c('div', {
    staticClass: "tab-content",
    attrs: {
      "id": "myTabContent"
    }
  }, [(_vm.controllSwithPurchaseOrder == 1) ? _c('div', [(_vm.flagFormEvaluetionPurchaseOrder == 'toFill') ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [(
    !_vm.orderDataShow.attributes.is_from_linio_flag ||
    !_vm.orderDataShow.attributes.is_from_meli_flag
  ) ? _c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Precio de la web (USD)")]) : _c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Precio de la web (USD)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.costGrabr),
      expression: "costGrabr"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.controllSwithPurchaseOrder == 1 &&
          _vm.flagFormEvaluetionPurchaseOrder == 'toFill' &&
          _vm.readyToProcessIncompleteData != true &&
          this.orderDataShow.attributes.status != 3,
      }),
      expression: "{\n                        required:\n                          controllSwithPurchaseOrder == 1 &&\n                          flagFormEvaluetionPurchaseOrder == 'toFill' &&\n                          readyToProcessIncompleteData != true &&\n                          this.orderDataShow.attributes.status != 3,\n                      }"
    }, {
      name: "floatonly",
      rawName: "v-floatonly"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "name": "precio_web",
      "maxlength": 7
    },
    domProps: {
      "value": (_vm.costGrabr)
    },
    on: {
      "keyup": function($event) {
        return _vm.setTaxGrabr()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.costGrabr = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit.\n                        Voluptates quod ut, aperiam laboriosa")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('precio_web')),
      expression: "errors.has('precio_web')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first("precio_web")))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "width": "390px"
    }
  }, [(
    !_vm.orderDataShow.attributes.is_from_linio_flag ||
    !_vm.orderDataShow.attributes.is_from_meli_flag
  ) ? _c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Impuesto de la web (USD)")]) : _c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Impuesto de la web (USD)")]), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "12px",
      "cursor": "pointer",
      "color": "cornflowerblue",
      "text-decoration": "underline"
    },
    on: {
      "click": _vm.resetImpuestoWeb
    }
  }, [_vm._v("(Limpiar campos)")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: this.controllSwithPurchaseOrder == 1 &&
          this.flagFormEvaluetionPurchaseOrder == 'toFill' &&
          this.readyToProcessIncompleteData != true &&
          this.orderDataShow.attributes.status != 3,
      }),
      expression: "{\n                        required:\n                          this.controllSwithPurchaseOrder == 1 &&\n                          this.flagFormEvaluetionPurchaseOrder == 'toFill' &&\n                          this.readyToProcessIncompleteData != true &&\n                          this.orderDataShow.attributes.status != 3,\n                      }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.taxGrabr),
      expression: "taxGrabr"
    }, {
      name: "floatonly",
      rawName: "v-floatonly"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "type": "text",
      "aria-describedby": "email",
      "name": "impuesto_web",
      "maxlength": 7
    },
    domProps: {
      "value": (_vm.taxGrabr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.taxGrabr = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit.\n                        Voluptates quod ut, aperiam laboriosa")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('impuesto_web')),
      expression: "errors.has('impuesto_web')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first("impuesto_web")))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(
    !_vm.orderDataShow.attributes.is_from_linio_flag ||
    !_vm.orderDataShow.attributes.is_from_meli_flag
  ) ? _c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Costo de envío de la web (USD)")]) : _c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Costo de envío de la web (USD)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.controllSwithPurchaseOrder == 1 &&
          _vm.flagFormEvaluetionPurchaseOrder == 'toFill' &&
          _vm.readyToProcessIncompleteData != true &&
          this.orderDataShow.attributes.status != 3,
      }),
      expression: "{\n                        required:\n                          controllSwithPurchaseOrder == 1 &&\n                          flagFormEvaluetionPurchaseOrder == 'toFill' &&\n                          readyToProcessIncompleteData != true &&\n                          this.orderDataShow.attributes.status != 3,\n                      }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.shippingGrabr),
      expression: "shippingGrabr"
    }, {
      name: "floatonly",
      rawName: "v-floatonly"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "type": "text",
      "aria-describedby": "email",
      "name": "costo_envio_web"
    },
    domProps: {
      "value": (_vm.shippingGrabr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shippingGrabr = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit.\n                        Voluptates quod ut, aperiam laboriosa")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('costo_envio_web')),
      expression: "errors.has('costo_envio_web')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first("costo_envio_web")))])]), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_grabr_flag) ? _c('div', {
    staticClass: "form-group adeudo-cal"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_c('a', {
    staticClass: "adeudo-link",
    attrs: {
      "href": 'http://paypal.me/EnviosDeUsa/' +
        Number(
          Math.round(parseFloat(_vm.debitCalculated * 1.07) + 'e2') +
          'e-2'
        )
        .toFixed(2)
        .toString(),
      "target": "_blank"
    }
  }, [_vm._v("Adeudo calculado (USD) :\n                        " + _vm._s(Number(
    Math.round(parseFloat(_vm.debitCalculated) + "e2") + "e-2"
  ).toFixed(2)))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Unidades de peso")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.controllSwithPurchaseOrder == 1 &&
          _vm.flagFormEvaluetionPurchaseOrder == 'toFill' &&
          _vm.readyToProcessIncompleteData != true &&
          this.orderDataShow.attributes.status != 3,
      }),
      expression: "{\n                        required:\n                          controllSwithPurchaseOrder == 1 &&\n                          flagFormEvaluetionPurchaseOrder == 'toFill' &&\n                          readyToProcessIncompleteData != true &&\n                          this.orderDataShow.attributes.status != 3,\n                      }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.unitWeight),
      expression: "unitWeight"
    }],
    staticClass: "form-control form-control-lg sen-form-input-with-tooltip",
    attrs: {
      "name": "unidad_peso"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.unitWeight = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Selecciona la unidad")]), _vm._v(" "), _vm._l((_vm.listUnits), function(units) {
    return _c('option', {
      key: units.id,
      domProps: {
        "value": units
      }
    }, [_vm._v("\n                        " + _vm._s(units.attributes.name) + "\n                      ")])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit.\n                        Voluptates quod ut, aperiam laboriosa")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('unidad_peso')),
      expression: "errors.has('unidad_peso')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first("unidad_peso")))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Peso de la orden")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.controllSwithPurchaseOrder == 1 &&
          _vm.flagFormEvaluetionPurchaseOrder == 'toFill' &&
          _vm.readyToProcessIncompleteData != true &&
          this.orderDataShow.attributes.status != 3,
      }),
      expression: "{\n                        required:\n                          controllSwithPurchaseOrder == 1 &&\n                          flagFormEvaluetionPurchaseOrder == 'toFill' &&\n                          readyToProcessIncompleteData != true &&\n                          this.orderDataShow.attributes.status != 3,\n                      }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.weightGrabr),
      expression: "weightGrabr"
    }, {
      name: "floatonly",
      rawName: "v-floatonly"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "aria-describedby": "email",
      "name": "peso_orden",
      "maxlength": 8
    },
    domProps: {
      "value": (_vm.weightGrabr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.weightGrabr = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit.\n                        Voluptates quod ut, aperiam laboriosa")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('peso_orden')),
      expression: "errors.has('peso_orden')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first("peso_orden")))])])]) : _vm._e(), _vm._v(" "), (_vm.flagFormEvaluetionPurchaseOrder == 'toShow') ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [(
    !_vm.orderDataShow.attributes.is_from_linio_flag ||
    !_vm.orderDataShow.attributes.is_from_meli_flag
  ) ? _c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Precio de la web (USD)")]) : _c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Precio de la web (USD)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.costGrabr),
      expression: "costGrabr"
    }],
    staticClass: "form-control null",
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": (_vm.costGrabr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.costGrabr = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(
    !_vm.orderDataShow.attributes.is_from_linio_flag ||
    !_vm.orderDataShow.attributes.is_from_meli_flag
  ) ? _c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Impuesto de la web (USD)")]) : _c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Impuesto de la web (USD)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.taxGrabr),
      expression: "taxGrabr"
    }],
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.taxGrabr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.taxGrabr = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(
    !_vm.orderDataShow.attributes.is_from_linio_flag ||
    !_vm.orderDataShow.attributes.is_from_meli_flag
  ) ? _c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Costo de envío de la web (USD)")]) : _c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Costo de envío de la web (USD)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shippingGrabr),
      expression: "shippingGrabr"
    }],
    staticClass: "form-control null",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.shippingGrabr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shippingGrabr = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Unidades de peso")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.unitWeight.attributes.name),
      expression: "unitWeight.attributes.name"
    }],
    staticClass: "form-control form-control-lg sen-form-input-with-tooltip",
    attrs: {
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.unitWeight.attributes, "name", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": ""
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.unitWeight.attributes.name) + "\n                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit.\n                        Voluptates quod ut, aperiam laboriosa")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Peso de la orden")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.weightGrabr),
      expression: "weightGrabr"
    }],
    staticClass: "form-control null",
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": (_vm.weightGrabr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.weightGrabr = $event.target.value
      }
    }
  })])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.controllSwithPurchaseOrder == 2) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [(
    !_vm.orderDataShow.attributes.is_from_linio_flag ||
    !_vm.orderDataShow.attributes.is_from_meli_flag
  ) ? _c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Precio real (USD)")]) : _c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Precio real (USD)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.controllSwithPurchaseOrder == 2 &&
          _vm.flagFormEvaluetionPurchaseOrder == 'toShow',
      }),
      expression: "{\n                      required:\n                        controllSwithPurchaseOrder == 2 &&\n                        flagFormEvaluetionPurchaseOrder == 'toShow',\n                    }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.CostReal),
      expression: "CostReal"
    }, {
      name: "floatonly",
      rawName: "v-floatonly"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "aria-describedby": "email",
      "name": "costo_real",
      "maxlength": 7
    },
    domProps: {
      "value": (_vm.CostReal)
    },
    on: {
      "keyup": function($event) {
        return _vm.setTaxReal()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.CostReal = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit.\n                      Voluptates quod ut, aperiam laboriosa")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('costo_real')),
      expression: "errors.has('costo_real')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first("costo_real")))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rewardFlag),
      expression: "rewardFlag"
    }],
    attrs: {
      "type": "checkbox",
      "id": "rewardFlag"
    },
    domProps: {
      "checked": Array.isArray(_vm.rewardFlag) ? _vm._i(_vm.rewardFlag, null) > -1 : (_vm.rewardFlag)
    },
    on: {
      "click": function($event) {
        return _vm.cambiarReward()
      },
      "change": function($event) {
        var $$a = _vm.rewardFlag,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.rewardFlag = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.rewardFlag = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.rewardFlag = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "reward-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Ingresar Reward / Discount")]), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit.\n                      Voluptates quod ut, aperiam laboriosa")])])]), _vm._v(" "), (_vm.rewardFlag) ? _c('div', {
    staticClass: "form-group"
  }, [(
    !_vm.orderDataShow.attributes.is_from_linio_flag ||
    !_vm.orderDataShow.attributes.is_from_meli_flag
  ) ? _c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Reward / Discount (USD)")]) : _c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Reward / Discount (S/)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.controllSwithPurchaseOrder == 2 &&
          _vm.flagFormEvaluetionPurchaseOrder == 'toShow',
      }),
      expression: "{\n                      required:\n                        controllSwithPurchaseOrder == 2 &&\n                        flagFormEvaluetionPurchaseOrder == 'toShow',\n                    }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.rewardDiscount),
      expression: "rewardDiscount"
    }, {
      name: "floatonly",
      rawName: "v-floatonly"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "id": "email",
      "name": "rewardDiscount",
      "aria-describedby": "email",
      "maxlength": 7
    },
    domProps: {
      "value": (_vm.rewardDiscount)
    },
    on: {
      "keyup": function($event) {
        return _vm.setTaxReal()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rewardDiscount = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit.\n                      Voluptates quod ut, aperiam laboriosa")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "width": "310px"
    }
  }, [(
    !_vm.orderDataShow.attributes.is_from_linio_flag ||
    !_vm.orderDataShow.attributes.is_from_meli_flag
  ) ? _c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Impuesto real (USD)")]) : _c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Impuesto real (USD)")]), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "12px",
      "cursor": "pointer",
      "color": "cornflowerblue",
      "text-decoration": "underline"
    },
    on: {
      "click": _vm.resetImpuestoReal
    }
  }, [_vm._v("(Limpiar campos)")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.controllSwithPurchaseOrder == 2 &&
          _vm.flagFormEvaluetionPurchaseOrder == 'toShow',
      }),
      expression: "{\n                      required:\n                        controllSwithPurchaseOrder == 2 &&\n                        flagFormEvaluetionPurchaseOrder == 'toShow',\n                    }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.TaxReal),
      expression: "TaxReal"
    }, {
      name: "floatonly",
      rawName: "v-floatonly"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "id": "email",
      "name": "real_tax",
      "aria-describedby": "email",
      "maxlength": 7
    },
    domProps: {
      "value": (_vm.TaxReal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.TaxReal = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit.\n                      Voluptates quod ut, aperiam laboriosa")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('real_tax')),
      expression: "errors.has('real_tax')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first("real_tax")))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(
    !_vm.orderDataShow.attributes.is_from_linio_flag ||
    !_vm.orderDataShow.attributes.is_from_meli_flag
  ) ? _c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Costos de envío real (USD)")]) : _c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Costos de envío real (USD)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.controllSwithPurchaseOrder == 2 &&
          _vm.flagFormEvaluetionPurchaseOrder == 'toShow',
      }),
      expression: "{\n                      required:\n                        controllSwithPurchaseOrder == 2 &&\n                        flagFormEvaluetionPurchaseOrder == 'toShow',\n                    }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.shippingReal),
      expression: "shippingReal"
    }, {
      name: "floatonly",
      rawName: "v-floatonly"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "id": "email",
      "name": "real_delivery_cost",
      "aria-describedby": "email",
      "maxlength": 7
    },
    domProps: {
      "value": (_vm.shippingReal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shippingReal = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit.\n                      Voluptates quod ut, aperiam laboriosa")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('real_delivery_cost')),
      expression: "errors.has('real_delivery_cost')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first("real_delivery_cost")))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Link de compra final")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: this.orderDataShow.attributes.status === 3 &&
          _vm.orderDataShow.attributes.is_from_grabr_flag,
        url: true,
      }),
      expression: "{\n                      required:\n                        this.orderDataShow.attributes.status === 3 &&\n                        orderDataShow.attributes.is_from_grabr_flag,\n                      url: true,\n                    }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.finalBuyingLink),
      expression: "finalBuyingLink"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "type": "text",
      "aria-describedby": "email",
      "name": "link_compra_final",
      "maxlength": 200
    },
    domProps: {
      "value": (_vm.finalBuyingLink)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.finalBuyingLink = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit.\n                      Voluptates quod ut, aperiam laboriosa")])])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-right"
  }, [(_vm.orderDataShow.attributes.is_from_grabr_flag) ? _c('a', {
    attrs: {
      "href": 'https://grabr.io/account/conversations/' +
        _vm.orderDataShow.attributes.grabrOrder.attributes.grabr_chat_link,
      "target": "_blank"
    }
  }, [_c('span', {
    directives: [{
      name: "b-popover",
      rawName: "v-b-popover.hover.top",
      value: ('Link chat de compra'),
      expression: "'Link chat de compra'",
      modifiers: {
        "hover": true,
        "top": true
      }
    }],
    staticClass: "hiper-eva btn-primary"
  }, [_c('i', {
    staticClass: "far fa-comment-dots"
  })])]) : _vm._e(), _vm._v(" "), (_vm.orderDataShow.attributes.is_from_grabr_flag) ? _c('a', {
    attrs: {
      "href": 'https://grabr.io/es/grabs/' +
        _vm.orderDataShow.attributes.grabrOrder.attributes.grabr_order_number,
      "target": "_blank"
    }
  }, [_c('span', {
    directives: [{
      name: "b-popover",
      rawName: "v-b-popover.hover.top",
      value: ('Link orden de compra'),
      expression: "'Link orden de compra'",
      modifiers: {
        "hover": true,
        "top": true
      }
    }],
    staticClass: "hiper-eva btn-primary"
  }, [_c('i', {
    staticClass: "fas fa-shopping-cart"
  })])]) : _vm._e(), _vm._v(" "), (_vm.controllSwithPurchaseOrder == 1) ? _c('button', {
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": _vm.updateEvaluation
    }
  }, [_vm._v("\n            Guardar cambios\n          ")]) : _vm._e(), _vm._v(" "), (_vm.controllSwithPurchaseOrder == 2) ? _c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.sendEvaluation(_vm.id)
      }
    }
  }, [_vm._v("\n            Evaluar\n          ")]) : _vm._e(), _vm._v(" "), (_vm.controllSwithPurchaseOrder == 1) ? _c('button', {
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": function($event) {
        return _vm.modalControllPurchaseOrder(1)
      }
    }
  }, [_vm._v("\n            Continuar\n          ")]) : _vm._e()])])]), _vm._v(" "), _c('b-modal', {
    ref: "modalProcess",
    attrs: {
      "hide-footer": "",
      "hide-header": "",
      "centered": "",
      "id": "modalProcess"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [(_vm.orderDataShow.attributes.is_from_grabr_flag) ? _c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("\n            Datos de compra adicional de orden Grabr\n          ")]) : (_vm.orderDataShow.attributes.is_from_linio_flag) ? _c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("\n            Datos de compra adicional de orden Linio\n          ")]) : (_vm.orderDataShow.attributes.is_from_meli_flag) ? _c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("\n            Datos de compra adicional de orden Mercado Libre\n          ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.hideModalProcess
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body modal-scroll",
    attrs: {
      "id": "modal-body"
    }
  }, [_c('div', {
    staticClass: "form-login",
    attrs: {
      "id": "infoextra"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Link de compra final")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: this.orderDataShow.attributes.status === 3 &&
          _vm.orderDataShow.attributes.is_from_grabr_flag &&
          _vm.sendProcessFlag,
        url: this.orderDataShow.attributes.status === 3 &&
          _vm.orderDataShow.attributes.is_from_grabr_flag &&
          _vm.sendProcessFlag,
      }),
      expression: "{\n                  required:\n                    this.orderDataShow.attributes.status === 3 &&\n                    orderDataShow.attributes.is_from_grabr_flag &&\n                    sendProcessFlag,\n                  url:\n                    this.orderDataShow.attributes.status === 3 &&\n                    orderDataShow.attributes.is_from_grabr_flag &&\n                    sendProcessFlag,\n                }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.finalBuyingLink),
      expression: "finalBuyingLink"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "type": "text",
      "aria-describedby": "email",
      "name": "link_compra_final",
      "maxlength": 200
    },
    domProps: {
      "value": (_vm.finalBuyingLink)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.finalBuyingLink = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates\n                  quod ut, aperiam laboriosa")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('link_compra_final')),
      expression: "errors.has('link_compra_final')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first("link_compra_final")))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Código de compra")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: this.orderDataShow.attributes.status === 3 && _vm.sendProcessFlag,
      }),
      expression: "{\n                  required:\n                    this.orderDataShow.attributes.status === 3 && sendProcessFlag,\n                }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.finalBuyingCode),
      expression: "finalBuyingCode"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "type": "text",
      "aria-describedby": "email",
      "name": "codigo_compra",
      "maxlength": 20
    },
    domProps: {
      "value": (_vm.finalBuyingCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.finalBuyingCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates\n                  quod ut, aperiam laboriosa")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('codigo_compra')),
      expression: "errors.has('codigo_compra')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first("codigo_compra")))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(!_vm.otherCarrierFlag) ? _c('div', [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Seleccionar Carrier")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: this.orderDataShow.attributes.status === 3 && _vm.sendProcessFlag,
      }),
      expression: "{\n                    required:\n                      this.orderDataShow.attributes.status === 3 && sendProcessFlag,\n                  }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.carrier),
      expression: "carrier"
    }],
    staticClass: "form-control form-control-lg sen-form-input-with-tooltip",
    attrs: {
      "name": "transportista"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.carrier = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": ''
    }
  }, [_vm._v("Selecciona")]), _vm._v(" "), _vm._l((_vm.carrier_list), function(carrier, index) {
    return _c('option', {
      key: ("" + index),
      domProps: {
        "value": ("" + index)
      }
    }, [_vm._v("\n                    " + _vm._s(carrier.name) + "\n                  ")])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit.\n                    Voluptates quod ut, aperiam laboriosa")])]), _vm._v(" "), (false && _vm.carrier != '' && _vm.carrier_list[_vm.carrier].url != '') ? _c('a', {
    staticClass: "link-trans",
    attrs: {
      "href": _vm.carrier_list[_vm.carrier].url
    }
  }, [_vm._v(_vm._s(_vm.carrier_list[_vm.carrier].name))]) : _vm._e()]) : _c('div', [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Ingresa el nombre del transportista")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: this.orderDataShow.attributes.status === 3 && _vm.sendProcessFlag,
      }),
      expression: "{\n                    required:\n                      this.orderDataShow.attributes.status === 3 && sendProcessFlag,\n                  }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.otherCarrierName),
      expression: "otherCarrierName"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "type": "text",
      "aria-describedby": "email",
      "name": "other_carrier_name",
      "maxlength": 20
    },
    domProps: {
      "value": (_vm.otherCarrierName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.otherCarrierName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit.\n                    Voluptates quod ut, aperiam laboriosa")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.otherCarrierFlag),
      expression: "otherCarrierFlag"
    }],
    staticClass: "checkbox-style",
    attrs: {
      "type": "checkbox",
      "id": "otherCarrierFlag"
    },
    domProps: {
      "checked": Array.isArray(_vm.otherCarrierFlag) ? _vm._i(_vm.otherCarrierFlag, null) > -1 : (_vm.otherCarrierFlag)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.otherCarrierFlag,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.otherCarrierFlag = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.otherCarrierFlag = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.otherCarrierFlag = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "reward-label"
  }, [_vm._v("Otro transportista")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('transportista')),
      expression: "errors.has('transportista')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first("transportista")))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Número de tracking")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: this.orderDataShow.attributes.status === 3 && _vm.sendProcessFlag,
      }),
      expression: "{\n                  required:\n                    this.orderDataShow.attributes.status === 3 && sendProcessFlag,\n                }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.numberTracking),
      expression: "numberTracking"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "type": "text",
      "aria-describedby": "email",
      "name": "numero_tracking",
      "maxlength": 30
    },
    domProps: {
      "value": (_vm.numberTracking)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.numberTracking = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates\n                  quod ut, aperiam laboriosa")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('numero_tracking')),
      expression: "errors.has('numero_tracking')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first("numero_tracking")))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Fecha de llegada al origen")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: this.orderDataShow.attributes.status === 3 && _vm.sendProcessFlag,
      }),
      expression: "{\n                  required:\n                    this.orderDataShow.attributes.status === 3 && sendProcessFlag,\n                }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.postingDate),
      expression: "postingDate"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "type": "date",
      "aria-describedby": "email",
      "name": "fecha_llegada_origen",
      "max": "2100-01-01",
      "min": "1900-01-01"
    },
    domProps: {
      "value": (_vm.postingDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.postingDate = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates\n                  quod ut, aperiam laboriosa")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('fecha_llegada_origen')),
      expression: "errors.has('fecha_llegada_origen')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first("fecha_llegada_origen")))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Seleccionar operador de envío")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: this.orderDataShow.attributes.status === 3 && _vm.sendProcessFlag,
      }),
      expression: "{\n                  required:\n                    this.orderDataShow.attributes.status === 3 && sendProcessFlag,\n                }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.operatorOrigin),
      expression: "operatorOrigin"
    }],
    staticClass: "form-control form-control-lg sen-form-input-with-tooltip",
    attrs: {
      "name": "operador_envio"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.operatorOrigin = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": ''
    }
  }, [_vm._v("Selecciona")])]), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates\n                  quod ut, aperiam laboriosa")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('operador_envio')),
      expression: "errors.has('operador_envio')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first("operador_envio")))])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-right"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "disabled": !_vm.readyToSaveIncompleteData
    },
    on: {
      "click": _vm.updateIncompleOrderData
    }
  }, [_vm._v("\n            Guardar cambios\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button",
      "disabled": !_vm.readyToProcessIncompleteData
    },
    on: {
      "click": function($event) {
        return _vm.sendProcess(_vm.id)
      }
    }
  }, [_vm._v("\n            Procesar\n          ")])])])]), _vm._v(" "), _c('b-modal', {
    ref: "modalProcessNoGrabr",
    attrs: {
      "hide-footer": "",
      "hide-header": "",
      "centered": "",
      "id": "modalProcessNoGrabr"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("\n            Datos de compra adicional de orden Direct\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.hideModalProcessNoGrabr
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body modal-scroll",
    attrs: {
      "id": "modal-body"
    }
  }, [_c('div', {
    staticClass: "form-login",
    attrs: {
      "id": "infoextra"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Código de compra")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: this.orderDataShow.attributes.status === 3 && _vm.sendProcessFlag,
      }),
      expression: "{\n                  required:\n                    this.orderDataShow.attributes.status === 3 && sendProcessFlag,\n                }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.finalBuyingCode),
      expression: "finalBuyingCode"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "type": "text",
      "aria-describedby": "email",
      "name": "codigo_compra"
    },
    domProps: {
      "value": (_vm.finalBuyingCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.finalBuyingCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates\n                  quod ut, aperiam laboriosa")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('codigo_compra')),
      expression: "errors.has('codigo_compra')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first("codigo_compra")))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(!_vm.otherCarrierFlag) ? _c('div', [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Seleccionar transportista")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: this.orderDataShow.attributes.status === 3 && _vm.sendProcessFlag,
      }),
      expression: "{\n                    required:\n                      this.orderDataShow.attributes.status === 3 && sendProcessFlag,\n                  }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.carrier),
      expression: "carrier"
    }],
    staticClass: "form-control form-control-lg sen-form-input-with-tooltip",
    attrs: {
      "name": "transportista"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.carrier = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": ''
    }
  }, [_vm._v("Selecciona")]), _vm._v(" "), _vm._l((_vm.carrier_list), function(carrier, index) {
    return _c('option', {
      key: ("" + index),
      domProps: {
        "value": ("" + index)
      }
    }, [_vm._v("\n                    " + _vm._s(carrier.name) + "\n                  ")])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit.\n                    Voluptates quod ut, aperiam laboriosa")])]), _vm._v(" "), (_vm.carrier != '') ? _c('a', {
    staticClass: "link-trans",
    attrs: {
      "href": _vm.carrier_list[_vm.carrier].url,
      "target": "_blank"
    }
  }, [_vm._v("Enlace a " + _vm._s(_vm.carrier_list[_vm.carrier].name))]) : _vm._e()]) : _c('div', [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Ingresa el nombre del transportista")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: this.orderDataShow.attributes.status === 3 && _vm.sendProcessFlag,
      }),
      expression: "{\n                    required:\n                      this.orderDataShow.attributes.status === 3 && sendProcessFlag,\n                  }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.otherCarrierName),
      expression: "otherCarrierName"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "type": "text",
      "aria-describedby": "email",
      "name": "other_carrier_name",
      "maxlength": 20
    },
    domProps: {
      "value": (_vm.otherCarrierName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.otherCarrierName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit.\n                    Voluptates quod ut, aperiam laboriosa")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.otherCarrierFlag),
      expression: "otherCarrierFlag"
    }],
    staticClass: "checkbox-style",
    attrs: {
      "type": "checkbox",
      "id": "otherCarrierFlag"
    },
    domProps: {
      "checked": Array.isArray(_vm.otherCarrierFlag) ? _vm._i(_vm.otherCarrierFlag, null) > -1 : (_vm.otherCarrierFlag)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.otherCarrierFlag,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.otherCarrierFlag = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.otherCarrierFlag = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.otherCarrierFlag = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "reward-label"
  }, [_vm._v("Otro transportista")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('transportista')),
      expression: "errors.has('transportista')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first("transportista")))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Número de tracking")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: this.orderDataShow.attributes.status === 3 && _vm.sendProcessFlag,
      }),
      expression: "{\n                  required:\n                    this.orderDataShow.attributes.status === 3 && sendProcessFlag,\n                }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.numberTracking),
      expression: "numberTracking"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "type": "text",
      "aria-describedby": "email",
      "name": "numero_tracking",
      "maxlength": 30
    },
    domProps: {
      "value": (_vm.numberTracking)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.numberTracking = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates\n                  quod ut, aperiam laboriosa")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('numero_tracking')),
      expression: "errors.has('numero_tracking')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first("numero_tracking")))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Fecha de llegada al origen")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: this.orderDataShow.attributes.status === 3 && _vm.sendProcessFlag,
      }),
      expression: "{\n                  required:\n                    this.orderDataShow.attributes.status === 3 && sendProcessFlag,\n                }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.postingDate),
      expression: "postingDate"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "type": "date",
      "aria-describedby": "email",
      "name": "fecha_llegada_origen",
      "max": "2100-01-01",
      "min": "1900-01-01"
    },
    domProps: {
      "value": (_vm.postingDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.postingDate = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates\n                  quod ut, aperiam laboriosa")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('fecha_llegada_origen')),
      expression: "errors.has('fecha_llegada_origen')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first("fecha_llegada_origen")))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Entrega prometida")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: this.orderDataShow.attributes.status === 3 && _vm.sendProcessFlag,
      }),
      expression: "{\n                  required:\n                    this.orderDataShow.attributes.status === 3 && sendProcessFlag,\n                }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.sendingDate),
      expression: "sendingDate"
    }],
    staticClass: "form-control null sen-form-input-with-tooltip",
    attrs: {
      "type": "date",
      "aria-describedby": "email",
      "name": "fecha_llegada_cliente",
      "max": "2100-01-01",
      "min": "1900-01-01"
    },
    domProps: {
      "value": (_vm.sendingDate)
    },
    on: {
      "change": _vm.validar,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sendingDate = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates\n                  quod ut, aperiam laboriosa")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('fecha_llegada_cliente')),
      expression: "errors.has('fecha_llegada_cliente')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first("fecha_llegada_cliente")))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "float-left",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Seleccionar operador de envío")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: this.orderDataShow.attributes.status === 3 && _vm.sendProcessFlag,
      }),
      expression: "{\n                  required:\n                    this.orderDataShow.attributes.status === 3 && sendProcessFlag,\n                }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.operatorOrigin),
      expression: "operatorOrigin"
    }],
    staticClass: "form-control form-control-lg sen-form-input-with-tooltip",
    attrs: {
      "name": "operador_envio"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.operatorOrigin = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": ''
    }
  }, [_vm._v("Selecciona")])]), _vm._v(" "), _c('div', {
    staticClass: "sen-tooltip sen-tooltip-modal"
  }, [_c('span', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates\n                  quod ut, aperiam laboriosa")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('operador_envio')),
      expression: "errors.has('operador_envio')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first("operador_envio")))])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-right"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "disabled": !_vm.readyToSaveIncompleteData
    },
    on: {
      "click": _vm.updateIncompleOrderData
    }
  }, [_vm._v("\n            Guardar cambios\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button",
      "disabled": !_vm.readyToProcessIncompleteData
    },
    on: {
      "click": function($event) {
        return _vm.sendProcess(_vm.id)
      }
    }
  }, [_vm._v("\n            Procesar\n          ")])])])]), _vm._v(" "), _c('b-modal', {
    ref: "validacionmodal",
    attrs: {
      "hide-footer": "",
      "hide-header": "",
      "id": "validacionmodal"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close",
      "block": "",
      "centered": ""
    },
    on: {
      "click": _vm.hideModalValidation
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body modal-scroll modal-correcto text-center"
  }, [_c('div', {
    staticClass: "validacion-body"
  }, [_c('h1')])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "block": ""
    },
    on: {
      "click": _vm.hideModalValidation
    }
  }, [_vm._v("\n            Continuar\n          ")])])])]), _vm._v(" "), _c('b-modal', {
    ref: "cancelOrdermodal",
    attrs: {
      "hide-footer": "",
      "hide-header": "",
      "centered": "",
      "id": "cancelOrdermodal"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close",
      "block": ""
    },
    on: {
      "click": _vm.hideCancelValidation
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body modal-scroll modal-no-correcto text-center"
  }, [_c('div', {
    staticClass: "validacion-body"
  }, [_c('h1')])])])]), _vm._v(" "), _c('b-modal', {
    ref: "modalConfirmation",
    attrs: {
      "hide-footer": "",
      "hide-header": "",
      "centered": "",
      "id": "modalConfirmation"
    }
  }, [_c('div', {
    staticClass: "modal-Content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Confirmar acción:")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.hideModalConfirmation
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body modal-scroll",
    attrs: {
      "id": "modal-body"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('p', [_vm._v("\n              Se cambiará el estado de la orden a cancelado, esta acción no es\n              reversible. ¿Estas seguro de completar esta acción?\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.cancelatePurchaseOrder(_vm.id)
      }
    }
  }, [_vm._v("\n            Confirmar\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.hideModalConfirmation()
      }
    }
  }, [_vm._v("\n            Cancelar\n          ")])])])]), _vm._v(" "), _c('b-modal', {
    ref: "modalConfirmationDelete",
    attrs: {
      "hide-footer": "",
      "hide-header": "",
      "centered": "",
      "id": "modalConfirmationDelete"
    }
  }, [_c('div', {
    staticClass: "modal-Content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Confirmar acción:")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.hideModalConfirmationDelete
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body modal-scroll",
    attrs: {
      "id": "modal-body"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('p', [_vm._v("\n              Se eliminará la orden de forma física, esta acción no es reversible.\n              ¿Estas seguro de completar esta acción?\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.deletePurchaseOrder(_vm.id)
      }
    }
  }, [_vm._v("\n            Confirmar\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.hideModalConfirmationDelete()
      }
    }
  }, [_vm._v("\n            Cancelar\n          ")])])])]), _vm._v(" "), _c('div')], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-content-block"
  }, [_c('span', [_vm._v("Oferta por evaluar")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-content-block"
  }, [_c('span', [_vm._v("Oferta no aprobada")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-content-block"
  }, [_c('span', [_vm._v("Oferta aprobada")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "collapsed",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "data-toggle": "collapse",
      "data-target": "#collapseThree",
      "aria-expanded": "true",
      "aria-controls": "collapseThree"
    }
  }, [_c('div', {
    staticClass: "details-text up-arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-content-block"
  }, [_c('span', [_vm._v("Esperando revisión del administrador")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "collapsed",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "data-toggle": "collapse",
      "data-target": "#collapseThree",
      "aria-expanded": "true",
      "aria-controls": "collapseThree"
    }
  }, [_c('div', {
    staticClass: "details-text up-arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-content-block"
  }, [_c('span', [_vm._v("Listo para el flujo de tracking")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-content-block"
  }, [_c('span', [_vm._v("En proceso de tracking")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-content-block"
  }, [_c('span', [_vm._v("En proceso de tracking con retraso")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-content-container"
  }, [_c('div', {
    staticClass: "card-content-block"
  }, [_c('span', [_vm._v("Recibido y completando datos de recepción")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-content-block"
  }, [_c('span', [_vm._v("Listo para embarcar")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-title-separator"
  }, [_c('span', [_vm._v("Información de la orden")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "information1",
      "data-toggle": "collapse",
      "data-target": "#clientInformation1",
      "aria-expanded": "false",
      "aria-controls": "clientInformation1"
    }
  }, [_c('span', [_vm._v("Detalle de la orden")]), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "information2",
      "data-toggle": "collapse",
      "data-target": "#clientInformation2",
      "aria-expanded": "false",
      "aria-controls": "clientInformation2"
    }
  }, [_c('span', [_vm._v("Detalle de la cuenta")]), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Dirección:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Sin Dirección Registrada ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "information3",
      "data-toggle": "collapse",
      "data-target": "#clientInformation3",
      "aria-expanded": "false",
      "aria-controls": "clientInformation3"
    }
  }, [_c('span', [_vm._v("Detalle de envío")]), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "information4",
      "data-toggle": "collapse",
      "data-target": "#clientInformation4",
      "aria-expanded": "false",
      "aria-controls": "clientInformation4"
    }
  }, [_c('span', [_vm._v("Detalle del presupuesto")]), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "information5",
      "data-toggle": "collapse",
      "data-target": "#clientInformation5",
      "aria-expanded": "false",
      "aria-controls": "clientInformation5"
    }
  }, [_c('span', [_vm._v("Detalle de Pago")]), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "information6",
      "data-toggle": "collapse",
      "data-target": "#clientInformation6",
      "aria-expanded": "false",
      "aria-controls": "clientInformation6"
    }
  }, [_c('span', [_vm._v("Detalle de Tracking")]), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "headingclient",
      "data-toggle": "collapse",
      "data-target": "#collapseclient",
      "aria-expanded": "false",
      "aria-controls": "collapseclient"
    }
  }, [_c('span', [_vm._v("Datos del cliente")]), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "headingshipping",
      "data-toggle": "collapse",
      "data-target": "#collapseshipping",
      "aria-expanded": "false",
      "aria-controls": "collapseshipping"
    }
  }, [_c('span', [_vm._v("Datos de envío")]), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Método de entrega: ")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Recojo en oficina")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "headingorder",
      "data-toggle": "collapse",
      "data-target": "#collapseorder",
      "aria-expanded": "false",
      "aria-controls": "collapseorder"
    }
  }, [_c('span', [_vm._v("Datos de compra")]), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "headingclient",
      "data-toggle": "collapse",
      "data-target": "#collapsePago",
      "aria-expanded": "false",
      "aria-controls": "collapseclient"
    }
  }, [_c('span', [_vm._v("Datos de Pago")]), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-title-separator"
  }, [_c('span', [_vm._v("Comentarios")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-title-item"
  }, [_c('span', [_vm._v("No Gravado")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-title-item"
  }, [_c('span', [_vm._v(" Gravado")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-title-item"
  }, [_c('span', [_vm._v("IGV")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "informationD1",
      "data-toggle": "collapse",
      "data-target": "#clientInformationD1",
      "aria-expanded": "false",
      "aria-controls": "clientInformationD1"
    }
  }, [_c('span', [_vm._v("Order Evaluation")]), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Precio:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "number"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Cantidad:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "number"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Peso:")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "number"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-info"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Adjunto:")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "cursor": "not-allowed"
    }
  }, [_c('input', {
    staticClass: "form-control",
    staticStyle: {
      "pointer-events": "none"
    },
    attrs: {
      "type": "file"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "clientServicioCheckout",
      "aria-labelledby": "servicioCheckout"
    }
  }, [_c('div', {
    staticClass: "details-content-info"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', [_c('input', {
    staticClass: "form-control",
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "type": "text",
      "placeholder": "Ingresar respuesta",
      "required": "",
      "readonly": ""
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "cursor": "not-allowed"
    }
  }, [_c('input', {
    staticStyle: {
      "margin-bottom": "20px",
      "pointer-events": "none"
    },
    attrs: {
      "type": "file"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "form-control btn-primary",
    staticStyle: {
      "cursor": "not-allowed"
    },
    attrs: {
      "type": "button"
    }
  }, [_vm._v("\n                      Mandar respuesta\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "reasignarOrden",
      "data-toggle": "collapse",
      "data-target": "#clientOrderReasign",
      "aria-expanded": "false",
      "aria-controls": "clientOrderReasign"
    }
  }, [_c('span', [_vm._v("Reasignar orden")]), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "warehouseAsociar",
      "data-toggle": "collapse",
      "data-target": "#asociarWarehouse",
      "aria-expanded": "false",
      "aria-controls": "asociarWarehouse"
    }
  }, [_c('span', [_vm._v("Asociar Warehouse")]), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "warehouse",
      "data-toggle": "collapse",
      "data-target": "#clientWarehouse",
      "aria-expanded": "false",
      "aria-controls": "clientWarehouse"
    }
  }, [_c('span', [_vm._v("Warehouse")]), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "informationEntregaDeSendi",
      "data-toggle": "collapse",
      "data-target": "#clientInformationEntregaDeSendi",
      "aria-expanded": "false",
      "aria-controls": "clientInformationEntregaDeSendi"
    }
  }, [_c('span', [_vm._v("Entrega de Sendi")]), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Entrega :")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Descripción :")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Evidencia :")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "informationD31223",
      "data-toggle": "collapse",
      "data-target": "#clientInformationD31223",
      "aria-expanded": "false",
      "aria-controls": "clientInformationD31223"
    }
  }, [_c('span', [_vm._v("Tracking")]), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Código :")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Ruta :")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-info"
  }, [_c('div', {
    staticClass: "details-title-block"
  }, [_c('span', {
    staticClass: "details-title-item"
  }, [_vm._v("Tipo :")]), _vm._v(" "), _c('span', {
    staticClass: "details-title-item"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "informationD512",
      "data-toggle": "collapse",
      "data-target": "#clientInformationD512",
      "aria-expanded": "false",
      "aria-controls": "clientInformationD512"
    }
  }, [_c('span', [_vm._v("Historial de tracking")]), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "informationD5",
      "data-toggle": "collapse",
      "data-target": "#clientInformationD5",
      "aria-expanded": "false",
      "aria-controls": "clientInformationD5"
    }
  }, [_c('span', [_vm._v("Asignar Viajero")]), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details-content-title collapsed",
    attrs: {
      "id": "informationD3",
      "data-toggle": "collapse",
      "data-target": "#clientInformationD3",
      "aria-expanded": "false",
      "aria-controls": "clientInformationD3"
    }
  }, [_c('span', [_vm._v("International Shopper")]), _vm._v(" "), _c('div', {
    staticClass: "details-text up-arrow"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d62834a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/purchase-order-show-view.vue
// module id = 1876
// module chunks = 1